import React, { useState, useRef, useEffect } from 'react';
import './App.css';

// Google Sign-In configuration
const GOOGLE_CLIENT_ID = '964817227772-pj7ubu25huvenl8qao826rh8thjm07c0.apps.googleusercontent.com';

// Global Google Sign-In callback function
window.handleGoogleSignIn = function(response) {
  // This will be called by the Google Sign-In button
  // We'll handle this in the App component
  if (window.handleGoogleLoginCallback) {
    window.handleGoogleLoginCallback(response);
  }
};



// Authentication Form Component
function AuthForm({ mode, onSubmit, loading, onToggleMode, onGoogleLogin }) {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    password_confirm: '',
    first_name: '',
    last_name: ''
  });
  const [errors, setErrors] = useState({});
  const [showPasswordLogin, setShowPasswordLogin] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});

    // Basic validation
    const newErrors = {};
    
    if (!formData.username.trim()) {
      newErrors.username = 'Username is required';
    }
    
    if (!formData.password.trim()) {
      newErrors.password = 'Password is required';
    }

    if (mode === 'register') {
      if (!formData.email.trim()) {
        newErrors.email = 'Email is required';
      } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        newErrors.email = 'Email is invalid';
      }
      
      if (!formData.first_name.trim()) {
        newErrors.first_name = 'First name is required';
      }
      
      if (!formData.last_name.trim()) {
        newErrors.last_name = 'Last name is required';
      }
      
      if (formData.password !== formData.password_confirm) {
        newErrors.password_confirm = 'Passwords do not match';
      }
      
      if (formData.password.length < 8) {
        newErrors.password = 'Password must be at least 8 characters';
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // Submit form
    const result = await onSubmit(formData);
    
    if (!result.success) {
      if (typeof result.error === 'object') {
        setErrors(result.error);
      } else {
        setErrors({ general: result.error });
      }
    }
  };

  if (mode === 'login') {
    return (
      <div className="auth-form auth-form--login">
        {errors.general && (
          <div className="auth-error general-error">
            {errors.general}
          </div>
        )}

        <div className="google-signin-primary">
          <div className="google-signin-container">
            <div id="g_id_onload"></div>
            <div id="g_id_signin"></div>
          </div>
          <p className="google-signin-hint">
            Recommended — Gmail sign-in unlocks Premium features automatically
          </p>
        </div>

        <div className="google-signin-divider">
          <span>or</span>
        </div>

        {!showPasswordLogin ? (
          <button
            type="button"
            className="btn btn-secondary auth-alt-toggle"
            onClick={() => setShowPasswordLogin(true)}
          >
            Continue with username
          </button>
        ) : (
          <form className="auth-password-panel" onSubmit={handleSubmit}>
            <div className="auth-field">
              <label htmlFor="login-username">Username</label>
              <input
                id="login-username"
                type="text"
                name="username"
                value={formData.username}
                onChange={handleInputChange}
                className={errors.username ? 'error' : ''}
                placeholder="demo"
                autoComplete="username"
              />
              {errors.username && (
                <div className="auth-error">{errors.username}</div>
              )}
            </div>

            <div className="auth-field">
              <label htmlFor="login-password">Password</label>
              <input
                id="login-password"
                type="password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                className={errors.password ? 'error' : ''}
                placeholder="••••••••"
                autoComplete="current-password"
              />
              {errors.password && (
                <div className="auth-error">{errors.password}</div>
              )}
            </div>

            <button
              type="submit"
              className="auth-submit"
              disabled={loading}
            >
              {loading ? 'Logging in…' : 'Login'}
            </button>

            <button
              type="button"
              className="auth-alt-hide"
              onClick={() => setShowPasswordLogin(false)}
            >
              Hide username login
            </button>
          </form>
        )}
      </div>
    );
  }

  return (
    <form className="auth-form" onSubmit={handleSubmit}>
      {errors.general && (
        <div className="auth-error general-error">
          {errors.general}
        </div>
      )}
      
      <div className="auth-field">
        <label>Username:</label>
        <input
          type="text"
          name="username"
          value={formData.username}
          onChange={handleInputChange}
          className={errors.username ? 'error' : ''}
          autoComplete="username"
        />
        {errors.username && (
          <div className="auth-error">{errors.username}</div>
        )}
      </div>

      <>
        <div className="auth-field">
          <label>Email:</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            className={errors.email ? 'error' : ''}
          />
          {errors.email && (
            <div className="auth-error">{errors.email}</div>
          )}
        </div>

        <div className="auth-fields-row">
          <div className="auth-field">
            <label>First Name:</label>
            <input
              type="text"
              name="first_name"
              value={formData.first_name}
              onChange={handleInputChange}
              className={errors.first_name ? 'error' : ''}
            />
            {errors.first_name && (
              <div className="auth-error">{errors.first_name}</div>
            )}
          </div>
          
          <div className="auth-field">
            <label>Last Name:</label>
            <input
              type="text"
              name="last_name"
              value={formData.last_name}
              onChange={handleInputChange}
              className={errors.last_name ? 'error' : ''}
            />
            {errors.last_name && (
              <div className="auth-error">{errors.last_name}</div>
            )}
          </div>
        </div>
      </>

      <div className="auth-field">
        <label>Password:</label>
        <input
          type="password"
          name="password"
          value={formData.password}
          onChange={handleInputChange}
          className={errors.password ? 'error' : ''}
          autoComplete="new-password"
        />
        {errors.password && (
          <div className="auth-error">{errors.password}</div>
        )}
      </div>

      <div className="auth-field">
        <label>Confirm Password:</label>
        <input
          type="password"
          name="password_confirm"
          value={formData.password_confirm}
          onChange={handleInputChange}
          className={errors.password_confirm ? 'error' : ''}
          autoComplete="new-password"
        />
        {errors.password_confirm && (
          <div className="auth-error">{errors.password_confirm}</div>
        )}
      </div>

      <div className="auth-form-footer">
        <button 
          type="submit" 
          className="auth-submit"
          disabled={loading}
        >
          {loading ? 'Registering…' : 'Register'}
        </button>
      </div>
    </form>
  );
}

function App() {
  // Authentication state
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [authMode, setAuthMode] = useState('login'); // 'login' or 'register'
  const [authLoading, setAuthLoading] = useState(false);
  
  // User tier and limits state
  const [userLimits, setUserLimits] = useState(null);
  const [userLimitsLoading, setUserLimitsLoading] = useState(false);
  
  // Mobile CTA state
  const [isMobileCTAExpanded, setIsMobileCTAExpanded] = useState(false);
  
  // Auto-collapse mobile CTA on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (isMobileCTAExpanded) {
        setIsMobileCTAExpanded(false);
      }
    };
    
    if (isMobileCTAExpanded) {
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [isMobileCTAExpanded]);

  // State management
  const [globalSettings, setGlobalSettings] = useState({
    initialEquity: 20000,
    slippage: 0.15,
    brokerFee: 20,
    stopLoss: 'No',
    distributeEquityEqually: false
  });

  const [selectedMaxYears, setSelectedMaxYears] = useState(4); // Default 4 years for all users
  const [timeframes, setTimeframes] = useState({
    1: true,
    2: true,
    3: true,
    4: true,
    5: false,
    6: false,
    7: false,
    8: false,
    9: false,
    10: false
  });

  const [strategyInstances, setStrategyInstances] = useState([
    {
      id: 'sma-crossover-1',
      name: 'SMA-Crossover-1',
      type: 'SMA-Crossover',
      enabled: true,
      params: {
        shortWindow: 20,
        longWindow: 50
      }
    },
    {
      id: 'rsi-mean-reversion-1',
      name: 'RSI-Mean-Reversion-1',
      type: 'RSI-Mean-Reversion',
      enabled: true,
      params: {
        period: 14,
        oversold: 30,
        overbought: 70
      }
    }
  ]);

  // Strategy parameters state (keeping for backward compatibility)
  const [strategyParams, setStrategyParams] = useState({});

  const [stocks, setStocks] = useState([
    { id: 1, market: 'US', symbol: 'MSFT' },
    { id: 2, market: 'US', symbol: 'TSM' }
  ]);

  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [aiAnalysis, setAiAnalysis] = useState(null);
  const [aiLoading, setAiLoading] = useState(false);
  const [notification, setNotification] = useState(null);
  const [showFreeBanner, setShowFreeBanner] = useState(true);


  // Tab state
  const [activeTab, setActiveTab] = useState('stocks');
  // Main canvas modes when on Stocks & Strategies: setup | results | ai
  const [workspaceMode, setWorkspaceMode] = useState('setup');

  // Refs for scrolling
  const aiAnalysisRef = useRef(null);
  const aiAnalysisLoadingRef = useRef(null);
  const backtestLoadingRef = useRef(null);
  const workspaceTopRef = useRef(null);

  // Progress states
  const [backtestProgress, setBacktestProgress] = useState(0);
  const [backtestStatus, setBacktestStatus] = useState('');
  const [showBacktestModal, setShowBacktestModal] = useState(false);
  const [aiProgress, setAiProgress] = useState(0);
  const [aiStatus, setAiStatus] = useState('');
  const [showAiModal, setShowAiModal] = useState(false);
  
  // Results interaction states
  const [selectedStockStrategy, setSelectedStockStrategy] = useState(null);
  const [strategyRollupTimeframe, setStrategyRollupTimeframe] = useState('1');
  const [expandedRollupStrategy, setExpandedRollupStrategy] = useState(null);
  const [selectedTimeframeTab, setSelectedTimeframeTab] = useState('1');
  const [selectedStrategyFilter, setSelectedStrategyFilter] = useState('All');
  const [tradeEquityFilter, setTradeEquityFilter] = useState('All');
  const [tradeStrategyFilter, setTradeStrategyFilter] = useState('All');
  const [tradeExitReasonFilter, setTradeExitReasonFilter] = useState('All');
  
  // Top-level filters
  const [topLevelStockFilter, setTopLevelStockFilter] = useState('All');

  const [showStrategyParamsModal, setShowStrategyParamsModal] = useState(false);
  const [selectedStrategyForParams, setSelectedStrategyForParams] = useState(null);
  const [showAddStrategyModal, setShowAddStrategyModal] = useState(false);
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [showStrategyRollupModal, setShowStrategyRollupModal] = useState(false);
  const [selectedSubscriptionStrategy, setSelectedSubscriptionStrategy] = useState(null);
  const [paperSubscriptions, setPaperSubscriptions] = useState([]);
  const [paperSubscriptionsLoading, setPaperSubscriptionsLoading] = useState(false);
  const [paperSubscribeLoading, setPaperSubscribeLoading] = useState(false);
  const [showCustomizePaper, setShowCustomizePaper] = useState(false);
  const [paperCapitalInput, setPaperCapitalInput] = useState(20000);
  const [expandedPaperId, setExpandedPaperId] = useState(null);
  const [expandedSnapshotId, setExpandedSnapshotId] = useState(null);
  const [paperUpdatingId, setPaperUpdatingId] = useState(null);
  const [tooltipState, setTooltipState] = useState({
    visible: false,
    content: '',
    x: 0,
    y: 0
  });
  const [showScrollIndicator, setShowScrollIndicator] = useState(false);
  const [stockErrors, setStockErrors] = useState({});

  const validateStockDuplicates = (list) => {
    const errors = {};
    const symbolToMarkets = {};
    list.forEach((s) => {
      const sym = (s.symbol || '').trim().toUpperCase();
      const mkt = (s.market || '').trim().toUpperCase();
      if (!sym) return;
      if (!symbolToMarkets[sym]) symbolToMarkets[sym] = new Set();
      symbolToMarkets[sym].add(mkt);
    });
    Object.entries(symbolToMarkets).forEach(([sym, marketsSet]) => {
      if (marketsSet.size > 1) {
        const marketsStr = Array.from(marketsSet).join(', ');
        list.forEach((s) => {
          if ((s.symbol || '').trim().toUpperCase() === sym) {
            errors[s.id] = `Ticker ${sym} is already selected in markets: ${marketsStr}. Please choose another ticker.`;
          }
        });
      }
    });
    setStockErrors(errors);
    return Object.keys(errors).length > 0;
  };

  // Cleanup effect to restore body scroll when component unmounts
  useEffect(() => {
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  // Handle body scroll for subscription modal
  useEffect(() => {
    if (showSubscriptionModal) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
    
    // Cleanup on unmount
    return () => {
      document.body.classList.remove('modal-open');
      document.body.style.overflow = 'auto';
    };
  }, [showSubscriptionModal]);

  // Update selected timeframe tab when results change
  useEffect(() => {
    if (results && Object.keys(results).length > 0) {
      // Get the first available timeframe key
      const availableTimeframes = Object.keys(results).sort((a, b) => parseInt(a) - parseInt(b));
      const firstTimeframe = availableTimeframes[0];
      
      // Update selected timeframe tab if it's not in the available timeframes
      if (!availableTimeframes.includes(selectedTimeframeTab)) {
        setSelectedTimeframeTab(firstTimeframe);
      }
    }
  }, [results, selectedTimeframeTab]);

  // Default strategy rollup to most recent year slice when results arrive
  useEffect(() => {
    if (results && Object.keys(results).length > 0) {
      const availableTimeframes = Object.keys(results)
        .map((tf) => parseInt(tf, 10))
        .filter((n) => !Number.isNaN(n))
        .sort((a, b) => a - b);
      if (availableTimeframes.length > 0) {
        const preferred = availableTimeframes.includes(1) ? 1 : availableTimeframes[0];
        setStrategyRollupTimeframe(String(preferred));
        setExpandedRollupStrategy(null);
      }
    }
  }, [results]);

  // Backend API URL - single backend architecture (memoized to prevent re-renders)
  const backendApiUrl = React.useMemo(() => {
    let url;
    
    if (process.env.REACT_APP_API_URL) {
      // Use environment variable if set
      url = process.env.REACT_APP_API_URL;
      console.log('🔍 [AUTH DEBUG] Using REACT_APP_API_URL:', url);
    } else if (window.location.hostname === 'localhost') {
      // Local development
      url = 'http://localhost:5001';
      console.log('🔍 [AUTH DEBUG] Local development - using localhost:5001');
    } else {
      // Production server - use same protocol as frontend
      url = `${window.location.protocol}//${window.location.hostname}/api/`;
      console.log('🔍 [AUTH DEBUG] Production server - using same protocol as frontend');
      console.log('🔍 [AUTH DEBUG] Frontend protocol:', window.location.protocol);
      console.log('🔍 [AUTH DEBUG] Frontend hostname:', window.location.hostname);
      
      // Warn if not using HTTPS in production
      if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') {
        console.warn('⚠️ [AUTH DEBUG] WARNING: Frontend is not using HTTPS in production!');
        console.warn('⚠️ [AUTH DEBUG] This may cause mixed content issues.');
      }
    }
    
    console.log('🔍 [AUTH DEBUG] Final Backend API URL calculated:', url);
    return url;
  }, []); // Empty dependency array - only calculate once

  // Only log renders in development and limit frequency
  if (process.env.NODE_ENV === 'development') {
    console.log('🔍 [AUTH DEBUG] === APP COMPONENT RENDER ===');
    console.log('🔍 [AUTH DEBUG] App component initialized');
    console.log('🔍 [AUTH DEBUG] Current hostname:', window.location.hostname);
    console.log('🔍 [AUTH DEBUG] Current protocol:', window.location.protocol);
    console.log('🔍 [AUTH DEBUG] Backend API URL:', backendApiUrl);
  }

  // Helper function to clear all application state
  const fetchUserLimits = async () => {
    if (!isAuthenticated) return;
    
    setUserLimitsLoading(true);
    try {
      const response = await fetch(`${backendApiUrl}/api/auth/limits/`, {
        headers: getAuthHeaders()
      });
      
      if (response.ok) {
        const limits = await response.json();
        setUserLimits(limits);
      } else {
        console.error('Failed to fetch user limits');
      }
    } catch (error) {
      console.error('Error fetching user limits:', error);
    } finally {
      setUserLimitsLoading(false);
    }
  };

  const validateAction = async (action, currentCount = 0, additionalData = {}) => {
    if (!isAuthenticated) return { canPerform: false, message: 'Please log in first' };
    
    try {
      const response = await fetch(`${backendApiUrl}/api/auth/validate-action/`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({
          action,
          current_count: currentCount,
          ...additionalData
        })
      });
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error validating action:', error);
      return { canPerform: false, message: 'Network error' };
    }
  };

  const showUpgradePrompt = (message) => {
    setNotification({
      type: 'warning',
      message: message,
      duration: 5000
    });
  };

  const validateFeatureAccess = async (feature) => {
    if (!isAuthenticated) return { canPerform: false, message: 'Please log in first' };
    
    try {
      const response = await fetch(`${backendApiUrl}/api/auth/validate-feature/`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({ feature })
      });
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error validating feature access:', error);
      return { canPerform: false, message: 'Network error' };
    }
  };

  const clearAllState = () => {
    // Reset to default free user values (within FREE limits)
    setStocks([
      { id: 1, market: 'US', symbol: 'MSFT' },
      { id: 2, market: 'US', symbol: 'TSM' }
    ]);
    
    setStrategyInstances([
      {
        id: 'sma-crossover-1',
        name: 'SMA-Crossover-1',
        type: 'SMA-Crossover',
        enabled: true,
        params: {
          shortWindow: 20,
          longWindow: 50
        }
      },
      {
        id: 'rsi-mean-reversion-1',
        name: 'RSI-Mean-Reversion-1',
        type: 'RSI-Mean-Reversion',
        enabled: true,
        params: {
          period: 14,
          oversold: 30,
          overbought: 70
        }
      }
    ]);
    
    // Reset timeframes to default (4 years for all users)
    setSelectedMaxYears(4);
    setTimeframes({
      1: true,
      2: true,
      3: true,
      4: true,
      5: false,
      6: false,
      7: false,
      8: false,
      9: false,
      10: false
    });
    
    // Clear all other state
    setResults(null);
    setError(null);
    setLoading(false);
    setBacktestStatus('');
    setBacktestProgress(0);
    setShowBacktestModal(false);
    setAiAnalysis(null);
    setAiLoading(false);
    setAiProgress(0);
    setAiStatus('');
    setShowAiModal(false);
    setSelectedStockStrategy(null);
    setSelectedStrategyFilter('All');
    setTopLevelStockFilter('All');
    setActiveTab('stocks');
    setUserLimits(null);
    setShowFreeBanner(true);
  };

  // Authentication helper functions
  const getAuthToken = () => {
    const token = localStorage.getItem('access_token');
    console.log('🔍 [AUTH DEBUG] getAuthToken called, token:', token ? 'EXISTS' : 'NOT FOUND');
    return token;
  };

  const setAuthToken = (token) => {
    console.log('🔍 [AUTH DEBUG] setAuthToken called, setting token:', token ? 'EXISTS' : 'NOT FOUND');
    localStorage.setItem('access_token', token);
    console.log('🔍 [AUTH DEBUG] Token saved to localStorage');
  };

  const removeAuthToken = () => {
    console.log('🔍 [AUTH DEBUG] removeAuthToken called, clearing tokens...');
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    console.log('🔍 [AUTH DEBUG] Tokens removed from localStorage');
  };

  const getAuthHeaders = () => {
    const token = getAuthToken();
    return token ? {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    } : {
      'Content-Type': 'application/json'
    };
  };

  // Check authentication status on app load
  useEffect(() => {
    console.log('🔍 [AUTH DEBUG] === AUTHENTICATION CHECK EFFECT RUNNING ===');
    console.log('🔍 [AUTH DEBUG] App load - checking authentication status...');
    console.log('🔍 [AUTH DEBUG] Backend API URL:', backendApiUrl);
    console.log('🔍 [AUTH DEBUG] Effect dependencies - backendApiUrl:', backendApiUrl);
    
    const token = getAuthToken();
    console.log('🔍 [AUTH DEBUG] Token from localStorage:', token ? 'EXISTS' : 'NOT FOUND');
    
    if (token) {
      console.log('🔍 [AUTH DEBUG] Token found, verifying with backend...');
      
      // Verify token by trying to get user profile
      fetch(`${backendApiUrl}/api/auth/profile/`, {
        headers: getAuthHeaders()
      })
      .then(response => {
        console.log('🔍 [AUTH DEBUG] Profile API response status:', response.status);
        console.log('🔍 [AUTH DEBUG] Profile API response ok:', response.ok);
        
        if (response.ok) {
          return response.json();
        } else {
          throw new Error('Token invalid');
        }
      })
      .then(data => {
        console.log('🔍 [AUTH DEBUG] Profile API success, user data:', data);
        setIsAuthenticated(true);
        setUser(data);
        console.log('🔍 [AUTH DEBUG] Authentication state set to TRUE');
      })
      .catch((error) => {
        console.log('🔍 [AUTH DEBUG] Profile API failed:', error.message);
        console.log('🔍 [AUTH DEBUG] Clearing authentication state...');
        
        // Token is invalid, remove it and clear all state
        removeAuthToken();
        setIsAuthenticated(false);
        setUser(null);
        clearAllState();
        console.log('🔍 [AUTH DEBUG] Authentication state cleared');
      });
    } else {
      console.log('🔍 [AUTH DEBUG] No token found, user not authenticated');
    }
  }, [backendApiUrl]);

  // Fetch user limits when authenticated
  useEffect(() => {
    console.log('🔍 [AUTH DEBUG] Authentication state changed - isAuthenticated:', isAuthenticated, 'user:', !!user);
    if (isAuthenticated && user) {
      console.log('🔍 [AUTH DEBUG] Fetching user limits...');
      fetchUserLimits();
    }
  }, [isAuthenticated, user]);

  // Reset state based on user tier when limits are fetched
  useEffect(() => {
    if (userLimits && isAuthenticated) {
      // Clean starting defaults for all plans (users can add more within their limits)
      setStocks([
        { id: 1, market: 'US', symbol: 'MSFT' },
        { id: 2, market: 'US', symbol: 'TSM' }
      ]);
      setStrategyInstances([
        {
          id: 'sma-crossover-1',
          name: 'SMA-Crossover-1',
          type: 'SMA-Crossover',
          enabled: true,
          params: {
            shortWindow: 20,
            longWindow: 50
          }
        },
        {
          id: 'rsi-mean-reversion-1',
          name: 'RSI-Mean-Reversion-1',
          type: 'RSI-Mean-Reversion',
          enabled: true,
          params: {
            period: 14,
            oversold: 30,
            overbought: 70
          }
        }
      ]);
      
      // All users start with 4 years selected; max selectable comes from userLimits.max_years
      setSelectedMaxYears(4);
      setTimeframes({
        1: true,
        2: true,
        3: true,
        4: true,
        5: false,
        6: false,
        7: false,
        8: false,
        9: false,
        10: false
      });
    }
  }, [userLimits, isAuthenticated]);

  // Set up Google Sign-In callback
  useEffect(() => {
    window.handleGoogleLoginCallback = handleGoogleLogin;
    return () => {
      window.handleGoogleLoginCallback = null;
    };
  }, []);

  // Initialize Google Sign-In
  useEffect(() => {
    let resizeObserver = null;
    let initTimeout = null;

    const getGoogleButtonWidth = () => {
      const loginContainer = document.querySelector('.login-container');
      const signInDiv = document.getElementById('g_id_signin');
      const measureTarget = loginContainer || signInDiv?.parentElement;
      if (!measureTarget) return 280;

      const available = measureTarget.clientWidth;
      // Google button width must fit inside the card content area
      return Math.max(200, Math.min(340, available - 4));
    };

    const initGoogleSignIn = () => {
      if (!window.google?.accounts?.id) {
        initTimeout = setTimeout(initGoogleSignIn, 500);
        return;
      }

      const signInDiv = document.getElementById('g_id_signin');
      if (!signInDiv) return;

      signInDiv.innerHTML = '';

      try {
        window.google.accounts.id.initialize({
          client_id: GOOGLE_CLIENT_ID,
          callback: handleGoogleLogin
        });

        window.google.accounts.id.renderButton(signInDiv, {
          theme: 'outline',
          size: 'large',
          text: 'continue_with',
          shape: 'rectangular',
          logo_alignment: 'left',
          width: getGoogleButtonWidth()
        });
      } catch (error) {
        console.error('Error initializing Google Sign-In:', error);
      }
    };

    if (authMode === 'login' && !isAuthenticated) {
      initTimeout = setTimeout(initGoogleSignIn, 300);

      const loginContainer = document.querySelector('.login-container');
      if (loginContainer && typeof ResizeObserver !== 'undefined') {
        resizeObserver = new ResizeObserver(() => {
          initGoogleSignIn();
        });
        resizeObserver.observe(loginContainer);
      } else {
        window.addEventListener('resize', initGoogleSignIn);
      }
    }

    return () => {
      if (initTimeout) clearTimeout(initTimeout);
      if (resizeObserver) {
        resizeObserver.disconnect();
      } else {
        window.removeEventListener('resize', initGoogleSignIn);
      }
    };
  }, [authMode, isAuthenticated]); // Keep dependencies but add condition



  // Authentication functions
  const handleLogin = async (credentials) => {
    console.log('🔍 [AUTH DEBUG] handleLogin called with credentials:', credentials.username);
    setAuthLoading(true);
    try {
      console.log('🔍 [AUTH DEBUG] Making login request to:', `${backendApiUrl}/api/auth/login/`);
      
      const response = await fetch(`${backendApiUrl}/api/auth/login/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(credentials)
      });

      console.log('🔍 [AUTH DEBUG] Login response status:', response.status);
      const data = await response.json();
      console.log('🔍 [AUTH DEBUG] Login response data:', data);
      
      if (response.ok) {
        console.log('🔍 [AUTH DEBUG] Login successful, setting tokens and state...');
        // Clear any existing state for fresh session
        clearAllState();
        
        setAuthToken(data.tokens.access);
        localStorage.setItem('refresh_token', data.tokens.refresh);
        setIsAuthenticated(true);
        setUser(data.user);
        console.log('🔍 [AUTH DEBUG] Login complete, user authenticated');
        return { success: true };
      } else {
        console.log('🔍 [AUTH DEBUG] Login failed:', data.error);
        return { success: false, error: data.error || 'Login failed' };
      }
    } catch (error) {
      console.log('🔍 [AUTH DEBUG] Login network error:', error);
      return { success: false, error: 'Network error' };
    } finally {
      setAuthLoading(false);
    }
  };

  const handleRegister = async (userData) => {
    setAuthLoading(true);
    try {
      const response = await fetch(`${backendApiUrl}/api/auth/register/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(userData)
      });

      const data = await response.json();
      
      if (response.ok) {
        // Clear any existing state for fresh session
        clearAllState();
        
        setAuthToken(data.tokens.access);
        localStorage.setItem('refresh_token', data.tokens.refresh);
        setIsAuthenticated(true);
        setUser(data.user);
        return { success: true };
      } else {
        return { success: false, error: data };
      }
    } catch (error) {
      return { success: false, error: 'Network error' };
    } finally {
      setAuthLoading(false);
    }
  };

  const handleLogout = async () => {
    console.log('🔍 [AUTH DEBUG] handleLogout called');
    try {
      const refreshToken = localStorage.getItem('refresh_token');
      console.log('🔍 [AUTH DEBUG] Refresh token exists:', !!refreshToken);
      
      if (refreshToken) {
        console.log('🔍 [AUTH DEBUG] Making logout request to backend...');
        const response = await fetch(`${backendApiUrl}/api/auth/logout/`, {
          method: 'POST',
          headers: getAuthHeaders(),
          body: JSON.stringify({ refresh: refreshToken })
        });
        console.log('🔍 [AUTH DEBUG] Logout response status:', response.status);
      }
    } catch (error) {
      console.log('🔍 [AUTH DEBUG] Logout request failed:', error);
    } finally {
      console.log('🔍 [AUTH DEBUG] Clearing local authentication state...');
      // Clear all application state for fresh session
      removeAuthToken();
      setIsAuthenticated(false);
      setUser(null);
      setAuthMode('login'); // Reset to login mode to show Google Sign-In button
      clearAllState();
      console.log('🔍 [AUTH DEBUG] Logout complete, state cleared');
    }
  };

  const handleGoogleLogin = async (response) => {
    try {
      setAuthLoading(true);
      
      // Send the ID token to our backend
      const result = await fetch(`${backendApiUrl}/api/auth/google-login/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id_token: response.credential
        })
      });

      const data = await result.json();

      if (result.ok) {
        // Clear any existing state for fresh session
        clearAllState();
        
        // Store tokens
        setAuthToken(data.tokens.access);
        localStorage.setItem('refresh_token', data.tokens.refresh);
        
        // Set user and authentication state
        setUser(data.user);
        setIsAuthenticated(true);
        
        // Clear any previous errors
        setAuthMode('login');
        
        return { success: true };
      } else {
        return { success: false, error: data.error || 'Google login failed' };
      }
    } catch (error) {
      console.error('Google login error:', error);
      return { success: false, error: 'Network error during Google login' };
    } finally {
      setAuthLoading(false);
    }
  };

  // Strategy name standardization function
  const standardizeStrategyName = (strategyName) => {
    // For now, just return the strategy name as-is since backend already has correct names
    return strategyName;
  };

  // Function to get available stocks and strategies from results
  const getAvailableStocksAndStrategies = () => {
    const availableStocks = new Set();
    const availableStrategies = new Set();
    
    if (results) {
      // console.log('🔍 Available Stocks Debug - Results keys:', Object.keys(results));
      
      Object.keys(results).forEach(timeframe => {
        const timeframeData = results[timeframe];
        if (timeframeData && timeframeData.data) {
          const stockStrategies = processResultsData(timeframeData.data).stockStrategies;
          // console.log(`🔍 Available Stocks Debug - ${timeframe} timeframe:`, stockStrategies.map(ss => ss.ticker));
          
          stockStrategies.forEach(stockStrategy => {
            availableStocks.add(stockStrategy.ticker);
            availableStrategies.add(stockStrategy.strategy);
          });
        }
      });
    }
    
    const result = {
      stocks: Array.from(availableStocks).sort(),
      strategies: Array.from(availableStrategies).sort()
    };
    
    // console.log('🔍 Available Stocks Debug - Final result:', result);
    return result;
  };

  // Function to filter data based on top-level filters
  const filterDataByTopLevelFilters = (data) => {
    if (!data) return {};
    
    const filteredData = { ...data };
    
    // Filter by stock
    if (topLevelStockFilter !== 'All') {
      Object.keys(filteredData).forEach(timeframe => {
        if (filteredData[timeframe]) {
          // Filter metrics data
          if (filteredData[timeframe].data) {
            // Get the original data structure
            const originalData = filteredData[timeframe].data;
            
            // Filter each row to keep only columns that contain the selected stock
            const filteredDataArray = originalData.map(row => {
              const filteredRow = { metric: row.metric };
              Object.keys(row).forEach(key => {
                if (key === 'metric') return; // Skip metric column
                // Check if the key contains the stock name (handle stocks with any exchange suffix)
                const stockNameWithoutSuffix = topLevelStockFilter.replace(/\.(NS|NSE|BSE|BO|BOM|NSEI|BSESN)$/i, '');
                const keyContainsStock = key.includes(topLevelStockFilter) || key.includes(stockNameWithoutSuffix);
                
                if (keyContainsStock) {
                  filteredRow[key] = row[key];
                }
              });
              return filteredRow;
            });
            
            // Update the filtered data
            filteredData[timeframe] = {
              ...filteredData[timeframe],
              data: filteredDataArray
            };
          }
          
          // Filter trades data
          if (filteredData[timeframe].trades) {
            const stockNameWithoutSuffix = topLevelStockFilter.replace(/\.(NS|NSE|BSE|BO|BOM|NSEI|BSESN)$/i, '');
            const filteredTrades = filteredData[timeframe].trades.filter(trade => {
              const tradeMatches = trade.equity === topLevelStockFilter || trade.equity === stockNameWithoutSuffix;
              return tradeMatches;
            });
            
            filteredData[timeframe] = {
              ...filteredData[timeframe],
              trades: filteredTrades
            };
          }
        }
      });
    }
    
    // Filter by strategy
    if (selectedStrategyFilter !== 'All') {
      Object.keys(filteredData).forEach(timeframe => {
        if (filteredData[timeframe]) {
          // Filter metrics data
          if (filteredData[timeframe].data) {
            // Get the original data structure
            const originalData = filteredData[timeframe].data;
            
            // Filter each row to keep only columns that contain the selected strategy
            const filteredDataArray = originalData.map(row => {
              const filteredRow = { metric: row.metric };
                                    Object.keys(row).forEach(key => {
                        if (key === 'metric') return; // Skip metric column
                        // Check if the key contains the strategy name
                        // Convert key from underscore format to hyphen format for comparison
                        const keyStrategyName = key.replace(/_/g, '-');
                        const keyContainsStrategy = keyStrategyName.includes(selectedStrategyFilter);
                        
                        if (keyContainsStrategy) {
                          filteredRow[key] = row[key];
                        }
                      });
              return filteredRow;
            });
            
            // Update the filtered data
            filteredData[timeframe] = {
              ...filteredData[timeframe],
              data: filteredDataArray
            };
          }
          
          // Filter trades data
          if (filteredData[timeframe].trades) {
            const filteredTrades = filteredData[timeframe].trades.filter(trade => {
              // Direct comparison since both frontend and backend now use hyphenated names
              const tradeMatches = trade.strategy_name === selectedStrategyFilter;
              return tradeMatches;
            });
            
            filteredData[timeframe] = {
              ...filteredData[timeframe],
              trades: filteredTrades
            };
          }
        }
      });
    }
    
    return filteredData;
  };

  // Function to calculate aggregated metrics for all stock-strategy combinations across all timeframes
  const calculateAggregatedMetrics = () => {
    const aggregatedData = {};
    
    // Get filtered results based on top-level filters
    const filteredResults = filterDataByTopLevelFilters(results);
    
    // Check if filteredResults is null or undefined
    if (!filteredResults) {
      return [];
    }
    
    // Process each timeframe
    Object.keys(filteredResults).forEach(timeframe => {
      const timeframeData = filteredResults[timeframe];
      if (timeframeData && timeframeData.data) {
        const stockStrategies = processResultsData(timeframeData.data).stockStrategies;
        
        stockStrategies.forEach(stockStrategy => {
          const key = `${stockStrategy.ticker}_${stockStrategy.strategy}`;
          
          if (!aggregatedData[key]) {
            aggregatedData[key] = {
              ticker: stockStrategy.ticker,
              strategy: stockStrategy.strategy,
              totalReturns: [],
              winRates: [],
              maxDrawdowns: [],
              cagrs: []
            };
          }
          
          aggregatedData[key].totalReturns.push(stockStrategy.totalReturn);
          aggregatedData[key].winRates.push(stockStrategy.winRate);
          aggregatedData[key].maxDrawdowns.push(stockStrategy.maxDrawdown);
          aggregatedData[key].cagrs.push(stockStrategy.cagr || 0);
        });
      }
    });
    
    // Calculate averages for each stock-strategy combination
    const aggregatedStockStrategies = Object.values(aggregatedData).map(item => {
      // Calculate total return across all years for this stock-strategy
      const totalReturnAcrossYears = calculateStockStrategySummary(item.ticker, item.strategy).totalReturnAcrossYears;
      
      return {
        id: `${item.ticker}_${item.strategy}`,
        ticker: item.ticker,
        strategy: item.strategy,
        avgTotalReturn: item.totalReturns.length > 0 ? 
          item.totalReturns.reduce((sum, val) => sum + val, 0) / item.totalReturns.length : 0,
        avgWinRate: item.winRates.length > 0 ? 
          item.winRates.reduce((sum, val) => sum + val, 0) / item.winRates.length : 0,
        avgMaxDrawdown: item.maxDrawdowns.length > 0 ? 
          item.maxDrawdowns.reduce((sum, val) => sum + val, 0) / item.maxDrawdowns.length : 0,
        avgCagr: item.cagrs.length > 0 ? 
          item.cagrs.reduce((sum, val) => sum + val, 0) / item.cagrs.length : 0,
        totalReturnAcrossYears: totalReturnAcrossYears
      };
    });
    
    return aggregatedStockStrategies;
  };

  const parsePercentMetric = (value) => {
    if (value == null || value === 'N/A') return null;
    const numericValue = parseFloat(String(value).replace(/[+%]/g, ''));
    return Number.isNaN(numericValue) ? null : numericValue;
  };

  const parseCurrencyMetric = (value) => {
    if (value == null || value === 'N/A') return null;
    const numericValue = parseFloat(String(value).replace(/[^0-9.-]/g, ''));
    return Number.isNaN(numericValue) ? null : numericValue;
  };

  const aggregateAcrossStocks = (items, getReturnPct, getInitialEquity, getFinalEquity) => {
    if (!items.length) return null;

    const usePortfolioWeight =
      globalSettings.distributeEquityEqually &&
      items.every((item) => getInitialEquity(item) != null && getFinalEquity(item) != null);

    if (usePortfolioWeight) {
      const totalInitial = items.reduce((sum, item) => sum + getInitialEquity(item), 0);
      const totalFinal = items.reduce((sum, item) => sum + getFinalEquity(item), 0);
      if (totalInitial > 0) {
        return ((totalFinal - totalInitial) / totalInitial) * 100;
      }
    }

    const returns = items.map(getReturnPct).filter((val) => val != null);
    if (!returns.length) return null;
    return returns.reduce((sum, val) => sum + val, 0) / returns.length;
  };

  const calculateStrategyRollup = (timeframeKey) => {
    if (!results || !results[timeframeKey]?.data) return null;

    const { stockStrategies } = processResultsData(results[timeframeKey].data);
    if (!stockStrategies.length) return null;

    const bnhByTicker = {};
    stockStrategies.forEach((item) => {
      if (item.absoluteGrowth != null && bnhByTicker[item.ticker] == null) {
        bnhByTicker[item.ticker] = item.absoluteGrowth;
      }
    });

    const stockCount = Object.keys(bnhByTicker).length;
    const perStockInitial = stockCount > 0 ? globalSettings.initialEquity / stockCount : 0;

    const bnhItems = Object.entries(bnhByTicker).map(([ticker, growthPct]) => {
      const initialEquity = globalSettings.distributeEquityEqually
        ? perStockInitial
        : globalSettings.initialEquity;
      const finalEquity = initialEquity * (1 + growthPct / 100);
      return { ticker, growthPct, initialEquity, finalEquity };
    });

    const basketBnh = aggregateAcrossStocks(
      bnhItems,
      (item) => item.growthPct,
      (item) => item.initialEquity,
      (item) => item.finalEquity
    );

    const byStrategy = {};
    stockStrategies.forEach((item) => {
      if (!byStrategy[item.strategy]) {
        byStrategy[item.strategy] = [];
      }
      byStrategy[item.strategy].push(item);
    });

    const aggregationMethod = globalSettings.distributeEquityEqually
      ? 'Portfolio-weighted (split equity across stocks)'
      : 'Equal-weight average across stocks';

    const rollups = Object.entries(byStrategy).map(([strategy, items]) => {
      const aggregatedReturn = aggregateAcrossStocks(
        items,
        (item) => item.totalReturn,
        (item) => item.initialEquity,
        (item) => item.finalEquity
      );
      const alpha =
        aggregatedReturn != null && basketBnh != null ? aggregatedReturn - basketBnh : null;

      return {
        strategy,
        aggregatedReturn,
        alpha,
        stockCount: items.length,
        stocks: items
          .map((item) => ({
            ticker: item.ticker,
            strategyReturn: item.totalReturn,
            buyHoldReturn: bnhByTicker[item.ticker] ?? null
          }))
          .sort((a, b) => b.strategyReturn - a.strategyReturn)
      };
    }).sort((a, b) => (b.aggregatedReturn ?? -Infinity) - (a.aggregatedReturn ?? -Infinity));

    return {
      timeframeKey,
      basketBnh,
      aggregationMethod,
      rollups
    };
  };

  const formatSignedPercent = (value, digits = 1) => {
    if (value == null || Number.isNaN(value)) return 'N/A';
    return `${value >= 0 ? '+' : ''}${value.toFixed(digits)}%`;
  };

  const renderStrategyRollupPanel = () => {
    if (!results) return null;

    const rollupTimeframes = Object.keys(results)
      .map((tf) => parseInt(tf, 10))
      .filter((n) => !Number.isNaN(n))
      .sort((a, b) => a - b);
    const rollup = calculateStrategyRollup(strategyRollupTimeframe);

    if (!rollup || !rollup.rollups.length) {
      return (
        <p className="strategy-rollup-empty">Not enough data for strategy rollup analysis.</p>
      );
    }

    return (
      <div className="strategy-rollup-section strategy-rollup-section--modal">
        <div className="strategy-rollup-header">
          <div>
            <p className="strategy-rollup-subtitle">
              If each strategy ran on all selected stocks — compared to holding those stocks with no strategy.
            </p>
            <p className="strategy-rollup-method">{rollup.aggregationMethod}</p>
            <p className="strategy-rollup-period-note">
              Each period is one calendar year slice (1Y = most recent year, 2Y = prior year, etc.).
            </p>
          </div>
          {rollupTimeframes.length > 1 && (
            <div className="strategy-rollup-timeframe">
              <label htmlFor="strategy-rollup-timeframe">Period</label>
              <select
                id="strategy-rollup-timeframe"
                value={strategyRollupTimeframe}
                onChange={(e) => {
                  setStrategyRollupTimeframe(e.target.value);
                  setExpandedRollupStrategy(null);
                }}
              >
                {rollupTimeframes.map((tf) => (
                  <option key={tf} value={String(tf)}>{tf}Y</option>
                ))}
              </select>
            </div>
          )}
        </div>

        <div className="strategy-rollup-benchmark">
          <span className="strategy-rollup-benchmark-label">Basket buy &amp; hold ({strategyRollupTimeframe}Y)</span>
          <span className={`strategy-rollup-benchmark-value ${rollup.basketBnh >= 0 ? 'positive' : 'negative'}`}>
            {formatSignedPercent(rollup.basketBnh)}
          </span>
        </div>

        <div className="strategy-rollup-table-wrap">
          <table className="strategy-rollup-table">
            <thead>
              <tr>
                <th>Strategy</th>
                <th>Aggregated return</th>
                <th>vs B&amp;H (alpha)</th>
                <th>Stocks</th>
                <th aria-label="Expand" />
              </tr>
            </thead>
            <tbody>
              {rollup.rollups.map((row) => (
                <React.Fragment key={row.strategy}>
                  <tr
                    className={expandedRollupStrategy === row.strategy ? 'expanded' : ''}
                    onClick={() => setExpandedRollupStrategy(
                      expandedRollupStrategy === row.strategy ? null : row.strategy
                    )}
                  >
                    <td className="strategy-rollup-name">{row.strategy}</td>
                    <td className={row.aggregatedReturn >= 0 ? 'positive' : 'negative'}>
                      {formatSignedPercent(row.aggregatedReturn)}
                    </td>
                    <td className={row.alpha >= 0 ? 'positive' : 'negative'}>
                      {formatSignedPercent(row.alpha)}
                    </td>
                    <td>{row.stockCount}</td>
                    <td className="strategy-rollup-expand">{expandedRollupStrategy === row.strategy ? '▾' : '▸'}</td>
                  </tr>
                  {expandedRollupStrategy === row.strategy && (
                    <tr className="strategy-rollup-detail-row">
                      <td colSpan={5}>
                        <div className="strategy-rollup-stock-grid">
                          {row.stocks.map((stock) => (
                            <div key={`${row.strategy}-${stock.ticker}`} className="strategy-rollup-stock-item">
                              <strong>{stock.ticker}</strong>
                              <span className={stock.strategyReturn >= 0 ? 'positive' : 'negative'}>
                                Strategy {formatSignedPercent(stock.strategyReturn)}
                              </span>
                              <span className={stock.buyHoldReturn >= 0 ? 'positive' : 'negative'}>
                                B&amp;H {formatSignedPercent(stock.buyHoldReturn)}
                              </span>
                            </div>
                          ))}
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  // Tab configuration
  const tabs = [
    { id: 'stocks', label: 'Stocks & Strategies' },
    { id: 'paper', label: 'Paper Trading' },
    { id: 'settings', label: 'Settings' }
  ];

  const formatPlanName = (tier) => {
    if (tier === 'ULTRA_PREMIUM') return 'Ultra';
    if (tier === 'PREMIUM') return 'Premium';
    return 'Free';
  };

  const planPillClass = (tier) => {
    if (tier === 'ULTRA_PREMIUM') return 'ultra';
    if (tier === 'PREMIUM') return 'premium';
    return 'free';
  };

  const getPlanTooltipLines = (limits) => {
    if (!limits) return [];
    const lines = [
      `Up to ${limits.max_stocks} stocks`,
      `Up to ${limits.max_years} years of history`,
      limits.max_strategies == null
        ? 'Unlimited concurrent strategies'
        : `Up to ${limits.max_strategies} concurrent strategies`
    ];
    if (limits.is_ultra_premium) {
      lines.push('All strategies unlocked (including Adaptive)');
      lines.push('AI analysis and Excel export included');
    } else if (limits.is_premium_or_higher) {
      lines.push('Advanced strategies (Adaptive is Ultra-only)');
      lines.push('AI analysis and Excel export included');
    } else {
      lines.push('SMA and RSI strategies');
      lines.push('AI analysis and Excel export locked');
      lines.push('Paper trading locked');
    }
    if (limits.can_use_paper_trading) {
      const subLimit = limits.max_paper_subscriptions == null
        ? 'Unlimited paper subscriptions'
        : `Up to ${limits.max_paper_subscriptions} paper subscriptions`;
      lines.push(subLimit);
      lines.push(`Up to $${Number(limits.max_paper_capital).toLocaleString()} paper capital per subscription`);
    }
    return lines;
  };

  const strategyTypeToKey = {
    'SMA-Crossover': 'sma_crossover',
    'RSI-Mean-Reversion': 'rsi_mean_reversion',
    'Advanced-Trend-Following': 'trend_following',
    'Adaptive-Strategy': 'adaptive',
    'Advanced-Mean-Reversion': 'mean_reversion',
    'VWAP-Strategy': 'vwap_strategy',
    'Hybrid-Leading/Lagging': 'hybrid_leading_lagging',
    'Renko-Streak': 'renko_streak'
  };

  const isUsTicker = (ticker) => {
    const symbol = (ticker || '').toUpperCase().trim();
    if (!symbol) return false;
    return !symbol.endsWith('.NS') && !symbol.endsWith('.BO');
  };

  const findStrategyInstanceByName = (displayName) => (
    strategyInstances.find((instance) => instance.name === displayName)
  );

  const getDefaultPaperCapital = () => {
    const equity = globalSettings.initialEquity || 20000;
    const stockCount = Math.max(stocks.filter((stock) => stock.symbol.trim()).length, 1);
    if (globalSettings.distributeEquityEqually) {
      return Math.round((equity / stockCount) * 100) / 100;
    }
    return equity;
  };

  const formatPaperSignal = (signal) => {
    const labels = {
      FLAT: 'Flat (no position)',
      HOLD: 'Hold (in position)',
      PENDING_BUY: 'Buy pending (next open)',
      PENDING_SELL: 'Sell pending (next open)',
    };
    return labels[signal] || signal || '—';
  };

  const fetchPaperSubscriptions = async () => {
    if (!isAuthenticated) return;

    setPaperSubscriptionsLoading(true);
    try {
      const response = await fetch(`${backendApiUrl}/api/paper/subscriptions/`, {
        headers: getAuthHeaders(),
      });
      if (response.ok) {
        const data = await response.json();
        setPaperSubscriptions(data);
      }
    } catch (error) {
      console.error('Error fetching paper subscriptions:', error);
    } finally {
      setPaperSubscriptionsLoading(false);
    }
  };

  const handleStartPaperTrading = async () => {
    if (!selectedSubscriptionStrategy) return;

    const instance = findStrategyInstanceByName(selectedSubscriptionStrategy.strategy);
    if (!instance) {
      setNotification({
        type: 'error',
        message: 'Could not find strategy parameters. Re-run the backtest with this strategy enabled.',
        duration: 6000,
      });
      return;
    }

    setPaperSubscribeLoading(true);
    try {
      const response = await fetch(`${backendApiUrl}/api/paper/subscriptions/`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({
          ticker: selectedSubscriptionStrategy.ticker,
          strategy_display_name: selectedSubscriptionStrategy.strategy,
          strategy_key: strategyTypeToKey[instance.type] || instance.type,
          strategy_params: instance.params || {},
          paper_capital: paperCapitalInput || getDefaultPaperCapital(),
          slippage: globalSettings.slippage,
          broker_fee: globalSettings.brokerFee,
          stop_loss: globalSettings.stopLoss,
          backtest_snapshot: buildPaperBacktestSnapshot(
            selectedSubscriptionStrategy.ticker,
            selectedSubscriptionStrategy.strategy,
            selectedSubscriptionStrategy
          ),
        }),
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || data.detail || 'Failed to start paper trading');
      }

      setShowSubscriptionModal(false);
      setSelectedSubscriptionStrategy(null);
      setActiveTab('paper');
      await fetchPaperSubscriptions();
      setNotification({
        type: 'success',
        message: `Paper trading started for ${data.ticker} — ${data.strategy_display_name}`,
        duration: 6000,
      });
    } catch (error) {
      setNotification({
        type: 'error',
        message: error.message || 'Failed to start paper trading',
        duration: 6000,
      });
    } finally {
      setPaperSubscribeLoading(false);
    }
  };

  const updatePaperSubscriptionStatus = async (subscriptionId, status) => {
    try {
      const response = await fetch(`${backendApiUrl}/api/paper/subscriptions/${subscriptionId}/`, {
        method: 'PATCH',
        headers: getAuthHeaders(),
        body: JSON.stringify({ status }),
      });
      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.error || 'Update failed');
      }
      await fetchPaperSubscriptions();
    } catch (error) {
      setNotification({
        type: 'error',
        message: error.message || 'Failed to update subscription',
        duration: 5000,
      });
    }
  };

  const cancelPaperSubscription = async (subscriptionId) => {
    try {
      const response = await fetch(`${backendApiUrl}/api/paper/subscriptions/${subscriptionId}/`, {
        method: 'DELETE',
        headers: getAuthHeaders(),
      });
      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.error || 'Cancel failed');
      }
      await fetchPaperSubscriptions();
      setNotification({
        type: 'success',
        message: 'Paper subscription cancelled',
        duration: 4000,
      });
    } catch (error) {
      setNotification({
        type: 'error',
        message: error.message || 'Failed to cancel subscription',
        duration: 5000,
      });
    }
  };

  const runPaperSubscriptionNow = async (subscriptionId) => {
    setPaperUpdatingId(subscriptionId);
    try {
      const response = await fetch(`${backendApiUrl}/api/paper/subscriptions/${subscriptionId}/run/`, {
        method: 'POST',
        headers: getAuthHeaders(),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || 'Update failed');
      }
      await fetchPaperSubscriptions();
      const result = data.result || {};
      if (result.skipped) {
        if (result.mtm_refreshed) {
          setNotification({
            type: 'success',
            message: `Price refreshed @ $${Number(result.last_price).toFixed(2)} · equity $${Number(result.equity).toLocaleString(undefined, { maximumFractionDigits: 2 })}`,
            duration: 6000,
          });
        } else {
          setNotification({
            type: 'info',
            message: `Already up to date (${result.reason || 'skipped'})`,
            duration: 5000,
          });
        }
      } else {
        const days = result.days_processed || 1;
        const trades = result.trades_taken || 0;
        setNotification({
          type: 'success',
          message: `Caught up ${days} day${days === 1 ? '' : 's'} · ${trades} fill${trades === 1 ? '' : 's'} · ${formatPaperSignal(data.subscription?.current_signal)}`,
          duration: 6000,
        });
      }
    } catch (error) {
      setNotification({
        type: 'error',
        message: error.message || 'Failed to run paper update',
        duration: 5000,
      });
    } finally {
      setPaperUpdatingId(null);
    }
  };

  useEffect(() => {
    if (isAuthenticated && user) {
      fetchPaperSubscriptions();
    }
  }, [isAuthenticated, user]);

  useEffect(() => {
    if (showSubscriptionModal && selectedSubscriptionStrategy) {
      setPaperCapitalInput(getDefaultPaperCapital());
      setShowCustomizePaper(false);
    }
  }, [showSubscriptionModal, selectedSubscriptionStrategy, globalSettings.initialEquity, globalSettings.distributeEquityEqually, stocks]);

  useEffect(() => {
    if (activeTab === 'paper' && isAuthenticated) {
      fetchPaperSubscriptions();
    }
  }, [activeTab, isAuthenticated]);

  const BrandMark = () => (
    <div className="brand-mark" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 16l5-5 4 3 7-8" />
        <path d="M14 6h6v6" />
      </svg>
    </div>
  );

  // Strategy descriptions
  const strategyDescriptions = {
    'SMA-Crossover': 'Simple Moving Average crossover strategy (20/50 periods)',
    'RSI-Mean-Reversion': 'RSI-based mean reversion strategy (14-period, 30/70 levels)',
    'Advanced-Trend-Following': 'EMA, MACD, RSI, and ADX combination strategy',
    'Adaptive-Strategy': 'ADX-based adaptive strategy: Trending (breakout) + Ranging (mean reversion) + Uncertain (no trade)',
    'Advanced-Mean-Reversion': 'Stochastic, CCI, Williams %R, and Bollinger Bands strategy',
    'VWAP-Strategy': 'VWAP-based strategy with SMA and RSI confirmation (10-day VWAP, 20-day SMA, RSI 14-period)',
    'Hybrid-Leading/Lagging': 'Hybrid strategy combining leading (momentum) and lagging (trend) indicators for entries, leading-only for exits',
    'Renko-Streak': 'Daily Renko brick-streak (N green = buy, N red = sell). Box scales with price (% of close) or rolling ATR.'
  };

  // Handle global settings change
  const handleGlobalSettingChange = (setting, value) => {
    setGlobalSettings(prev => ({
      ...prev,
      [setting]: value
    }));
  };

  // Handle timeframe selection
  const handleTimeframeToggle = async (timeframe) => {
    // Check if user is trying to select a timeframe beyond their limit
    if (userLimits && timeframe > userLimits.max_years) {
      const validation = await validateAction('increase_years', 0, { requested_years: timeframe });
      
      if (!validation.can_perform) {
        showUpgradePrompt(validation.message);
        return;
      }
    }
    
    setTimeframes(prev => {
      const newTimeframes = { ...prev };
      const isCurrentlySelected = prev[timeframe];
      
      if (isCurrentlySelected) {
        // If deselecting, check if it would create a gap
        const selectedTimeframes = Object.keys(prev).filter(tf => prev[tf]);
        const selectedYears = selectedTimeframes.map(tf => parseInt(tf)).sort((a, b) => a - b);
        
        // Find the highest selected timeframe
        const maxSelectedYear = Math.max(...selectedYears);
        
        // Only allow deselection if this is the highest selected timeframe
        // or if deselecting it won't create a gap
        if (timeframe === maxSelectedYear) {
          newTimeframes[timeframe] = false;
        } else {
          // Show notification that deselection is not allowed
          setNotification({
            type: 'warning',
            message: `Cannot deselect ${timeframe} Year${timeframe > 1 ? 's' : ''} as it would create a gap. Please deselect timeframes from the highest selected timeframe down.`
          });
          // Clear notification after 3 seconds
          setTimeout(() => setNotification(null), 3000);
          return prev; // Return unchanged state
        }
      } else {
        // If selecting, ensure all timeframes from 1 to this timeframe are selected
        for (let i = 1; i <= timeframe; i++) {
          if (i in prev) {
            newTimeframes[i] = true;
          }
        }
        
        // Show notification about automatic selection
        if (timeframe > 1) {
          setNotification({
            type: 'info',
            message: `Selected ${timeframe} Year${timeframe > 1 ? 's' : ''}. All timeframes from 1 Year to ${timeframe} Year${timeframe > 1 ? 's' : ''} have been automatically selected to maintain continuity.`
          });
          // Clear notification after 3 seconds
          setTimeout(() => setNotification(null), 3000);
        }
      }
      
      return newTimeframes;
    });
  };

  // Handle strategy selection
  const handleStrategyToggle = (instanceId) => {
    setStrategyInstances(prev => 
      prev.map(instance => 
        instance.id === instanceId 
          ? { ...instance, enabled: !instance.enabled }
          : instance
      )
    );
  };

  const addStrategyInstance = async (strategyType) => {
    const validation = await validateAction('add_strategy', strategyInstances.length);
    
    if (!validation.can_perform) {
      showUpgradePrompt(validation.message);
      return;
    }
    
    const defaultParams = {
      'SMA-Crossover': {
        shortWindow: 20,
        longWindow: 50
      },
      'RSI-Mean-Reversion': {
        period: 14,
        oversold: 30,
        overbought: 70
      },
      'Advanced-Trend-Following': {
        emaShort: 12,
        emaLong: 26,
        macdSignal: 9,
        rsiPeriod: 14,
        adxPeriod: 14,
        rsiThresholdBuy: 60,
        rsiThresholdSell: 40,
        adxThreshold: 15
      },
      'Adaptive-Strategy': {
        adxPeriod: 14,
        adxTrendingThreshold: 25,
        adxRangingThreshold: 20,
        rsiPeriod: 2,
        rsiOversold: 10,
        rsiOverbought: 70,
        lookbackPeriod: 50,
        atrPeriod: 14,
        trailingStopMultiplier: 3,
        maxHoldingDays: 5
      },
      'Advanced-Mean-Reversion': {
        stochLength: 14,
        stochKPeriod: 3,
        cciLength: 20,
        williamsLength: 14,
        bbLength: 20,
        bbMult: 2.0,
        toleranceUpper: 0.01,
        toleranceLower: 0.01,
        stochOversold: 30,
        stochOverbought: 80,
        cciOversold: -90,
        cciOverbought: 76,
        williamsOversold: -70,
        williamsOverbought: -30
      },
      'VWAP-Strategy': {
        vwapPeriod: 10,
        smaPeriod: 20,
        rsiPeriod: 14,
        rsiBuyThreshold: 55,
        rsiSellThreshold: 65
      },
      'Hybrid-Leading/Lagging': {
        stochLength: 14,
        stochKPeriod: 3,
        stochOversold: 30,
        stochOverbought: 80,
        cciLength: 20,
        cciOversold: -90,
        cciOverbought: 76,
        williamsLength: 14,
        williamsOversold: -70,
        williamsOverbought: -30,
        bbLength: 20,
        bbMult: 2.0,
        toleranceUpper: 0.01,
        toleranceLower: 0.01,
        emaShort: 12,
        emaLong: 26,
        macdFast: 12,
        macdSlow: 26,
        macdSignal: 9,
        adxPeriod: 14,
        adxThreshold: 20
      },
      'Renko-Streak': {
        boxSizeMode: 'percent',
        boxSize: 5,
        boxPercent: 2,
        atrPeriod: 14,
        atrMultiplier: 1.5,
        streakLength: 3,
        trendFilter: 0,
        confirmNextBrick: 0
      }
    };

    const existingCount = strategyInstances.filter(instance => instance.type === strategyType).length;
    const newInstance = {
      id: `${strategyType.toLowerCase().replace(/\s+/g, '-')}-${existingCount + 1}`,
      name: `${strategyType}-${existingCount + 1}`,
      type: strategyType,
      enabled: true,
      params: defaultParams[strategyType] || {}
    };



    setStrategyInstances(prev => [...prev, newInstance]);
  };

  const removeStrategyInstance = (instanceId) => {
    setStrategyInstances(prev => prev.filter(instance => instance.id !== instanceId));
  };

  const updateStrategyInstanceParams = (instanceId, param, value, parseNumber = true) => {
    setStrategyInstances(prev => 
      prev.map(instance => 
        instance.id === instanceId 
          ? { 
              ...instance, 
              params: { 
                ...instance.params, 
                [param]: parseNumber
                  ? (value === '' ? '' : parseFloat(value))
                  : value
              } 
            }
          : instance
      )
    );
  };

  const handleStrategyParamChange = (instanceId, param, value, parseNumber = true) => {
    updateStrategyInstanceParams(instanceId, param, value, parseNumber);
  };

  const openStrategyParamsModal = (instanceId) => {
    setSelectedStrategyForParams(instanceId);
    setShowStrategyParamsModal(true);
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden';
    // Check for scroll indicator after modal opens
    setTimeout(() => {
      const modalContent = document.querySelector('.strategy-params-modal-content');
      if (modalContent) {
        setShowScrollIndicator(modalContent.scrollHeight > modalContent.clientHeight);
      }
    }, 100);
  };

  const closeStrategyParamsModal = () => {
    setShowStrategyParamsModal(false);
    setSelectedStrategyForParams(null);
    setShowScrollIndicator(false);
    // Restore body scroll when modal is closed
    document.body.style.overflow = 'auto';
  };

  const getParameterDescription = (strategy, param) => {
    const descriptions = {
      'SMA Crossover': {
        'shortWindow': 'Period for the short-term Simple Moving Average. Lower values make the strategy more responsive to recent price changes.',
        'longWindow': 'Period for the long-term Simple Moving Average. Higher values provide a longer-term trend perspective.'
      },
      'RSI Mean Reversion': {
        'period': 'Number of periods used to calculate the Relative Strength Index. Standard is 14 periods.',
        'oversold': 'RSI threshold below which the asset is considered oversold (buy signal). Default is 30.',
        'overbought': 'RSI threshold above which the asset is considered overbought (sell signal). Default is 70.'
      },
      'Advanced Trend-Following': {
        'emaShort': 'Period for the short-term Exponential Moving Average. Standard is 12 periods.',
        'emaLong': 'Period for the long-term Exponential Moving Average. Standard is 26 periods.',
        'macdSignal': 'Period for MACD signal line calculation. Standard is 9 periods.',
        'rsiPeriod': 'Period for RSI calculation. Standard is 14 periods.',
        'adxPeriod': 'Period for ADX calculation. Standard is 14 periods.',
        'rsiThresholdBuy': 'RSI threshold for buy signals in trend-following mode. Lower values are more conservative.',
        'rsiThresholdSell': 'RSI threshold for sell signals in trend-following mode. Higher values are more conservative.',
        'adxThreshold': 'Average Directional Index threshold. Higher values indicate stronger trends are required for signals.'
      },
      'Adaptive Strategy': {
        'adxPeriod': 'Period for ADX calculation. Standard is 14 periods.',
        'adxTrendingThreshold': 'ADX threshold to determine if market is trending. Above this value, trend-following rules apply.',
        'adxRangingThreshold': 'ADX threshold to determine if market is ranging. Below this value, mean-reversion rules apply.',
        'rsiPeriod': 'Period for RSI calculation in adaptive mode. Shorter periods are more responsive.',
        'rsiOversold': 'RSI oversold threshold for mean-reversion mode.',
        'rsiOverbought': 'RSI overbought threshold for mean-reversion mode.',
        'lookbackPeriod': 'Number of periods to look back for trend analysis.',
        'atrPeriod': 'Period for ATR calculation. Standard is 14 periods.',
        'trailingStopMultiplier': 'Multiplier for ATR to set trailing stop distance. Higher values provide more room for price movement.',
        'maxHoldingDays': 'Maximum number of days to hold a position before forced exit.'
      },
      'Advanced Mean-Reversion': {
        'stochLength': 'Period for Stochastic Oscillator calculation. Standard is 14 periods.',
        'stochKPeriod': 'Period for Stochastic %K smoothing. Standard is 3 periods.',
        'cciLength': 'Period for Commodity Channel Index calculation. Standard is 20 periods.',
        'williamsLength': 'Period for Williams %R calculation. Standard is 14 periods.',
        'bbLength': 'Period for Bollinger Bands calculation. Standard is 20 periods.',
        'bbMult': 'Standard deviation multiplier for Bollinger Bands. Higher values create wider bands.',
        'toleranceUpper': 'Tolerance level for upper Bollinger Band signals (as percentage).',
        'toleranceLower': 'Tolerance level for lower Bollinger Band signals (as percentage).',
        'stochOversold': 'Stochastic oversold threshold for buy signals. Default is 30.',
        'stochOverbought': 'Stochastic overbought threshold for sell signals. Default is 80.',
        'cciOversold': 'CCI oversold threshold for buy signals. Default is -90.',
        'cciOverbought': 'CCI overbought threshold for sell signals. Default is 76.',
        'williamsOversold': 'Williams %R oversold threshold for buy signals. Default is -70.',
        'williamsOverbought': 'Williams %R overbought threshold for sell signals. Default is -30.'
      },
      'VWAP Strategy': {
        'vwapPeriod': 'Period for Volume Weighted Average Price calculation. Recommended 10 days for swing setups - smooths price-volume action while maintaining volume sensitivity.',
        'smaPeriod': 'Period for Simple Moving Average calculation. Recommended 20 days for short-medium term trend following with less lag than 50-day.',
        'rsiPeriod': 'Period for RSI calculation. Industry standard 14 periods works well for both trend and reversal setups.',
        'rsiBuyThreshold': 'RSI threshold for buy signals. Recommended <55 for early momentum catch with trend filters in place.',
        'rsiSellThreshold': 'RSI threshold for sell signals. Recommended >65 to exit before overheating while avoiding late exits.'
      },
      'Hybrid Leading/Lagging': {
        'stochLength': 'Period for Stochastic calculation. Default 14 periods for momentum analysis.',
        'stochKPeriod': 'Period for Stochastic K smoothing. Default 3 periods.',
        'stochOversold': 'Stochastic oversold threshold for buy signals. Default 30.',
        'stochOverbought': 'Stochastic overbought threshold for sell signals. Default 80.',
        'cciLength': 'Period for CCI calculation. Default 20 periods.',
        'cciOversold': 'CCI oversold threshold for buy signals. Default -90.',
        'cciOverbought': 'CCI overbought threshold for sell signals. Default 76.',
        'williamsLength': 'Period for Williams %R calculation. Default 14 periods.',
        'williamsOversold': 'Williams %R oversold threshold for buy signals. Default -70.',
        'williamsOverbought': 'Williams %R overbought threshold for sell signals. Default -30.',
        'bbLength': 'Period for Bollinger Bands calculation. Default 20 periods.',
        'bbMult': 'Multiplier for Bollinger Bands standard deviation. Default 2.0.',
        'toleranceUpper': 'Tolerance level for upper Bollinger Band signals (as percentage).',
        'toleranceLower': 'Tolerance level for lower Bollinger Band signals (as percentage).',
        'emaShort': 'Short EMA period for trend confirmation. Default 12 periods.',
        'emaLong': 'Long EMA period for trend confirmation. Default 26 periods.',
        'macdFast': 'Fast EMA period for MACD. Default 12 periods.',
        'macdSlow': 'Slow EMA period for MACD. Default 26 periods.',
        'macdSignal': 'Signal line period for MACD. Default 9 periods.',
        'adxPeriod': 'Period for ADX calculation. Default 14 periods.',
        'adxThreshold': 'ADX threshold for trend strength confirmation. Default 20.'
      },
      'Renko-Streak': {
        'boxSizeMode': 'Brick height: Percent (% of price, recommended), ATR (rolling daily), or Manual (fixed units).',
        'boxSize': 'Manual brick size in price units. Used only when Box Size Mode is Manual.',
        'boxPercent': 'Brick height as % of current close when using Percent mode. Default 2%.',
        'atrPeriod': 'ATR lookback for ATR mode. Default 14 daily bars.',
        'atrMultiplier': 'Box = rolling ATR × multiplier in ATR mode. Default 1.5.',
        'streakLength': 'Consecutive same-color bricks to trigger entry/exit. Default 3.',
        'trendFilter': 'When enabled, only buy above prior day close and only sell below it.',
        'confirmNextBrick': 'Require one extra confirming brick after the streak before signaling (fewer whipsaws).'
      }
    };
    
    return descriptions[strategy]?.[param] || 'Parameter description not available.';
  };

  const showTooltip = (event, content) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    
    // Responsive tooltip width
    const tooltipWidth = screenWidth < 768 ? Math.min(280, screenWidth - 20) : 320;
    const tooltipHeight = 120; // Approximate height
    
    // Calculate x position, ensuring tooltip doesn't go off screen
    let x = rect.left + rect.width / 2;
    
    // On small screens, use full-width tooltip positioned at screen edges
    if (screenWidth < 768) {
      // For small screens, position tooltip at screen edges (CSS will handle the rest)
      x = 10; // This will be overridden by CSS
    } else {
      if (x + tooltipWidth / 2 > screenWidth) {
        x = screenWidth - tooltipWidth / 2 - 10;
      } else if (x - tooltipWidth / 2 < 0) {
        x = tooltipWidth / 2 + 10;
      }
    }
    
    // Calculate y position, ensuring tooltip doesn't go off screen
    let y = rect.bottom + 10;
    
    // Check if tooltip would go below screen
    if (y + tooltipHeight > screenHeight) {
      // If tooltip would go below screen, show it above the element
      y = rect.top - tooltipHeight - 10;
      
      // If still off screen, position it at the top with some margin
      if (y < 10) {
        y = 10;
      }
    }
    
    // Set tooltip state immediately for smooth positioning
    setTooltipState({
      visible: true,
      content,
      x,
      y
    });
  };

  const hideTooltip = () => {
    setTooltipState(prev => ({ ...prev, visible: false }));
  };

  // Handle stock changes
  const handleStockChange = (id, field, value) => {
    const updatedStocks = stocks.map(stock => 
      stock.id === id ? { ...stock, [field]: value } : stock
    );
    setStocks(updatedStocks);
    const hasDup = validateStockDuplicates(updatedStocks);
    if (hasDup) {
      setNotification({
        type: 'warning',
        message: 'Duplicate ticker across different markets detected. Please choose another ticker.',
        duration: 6000
      });
    }
  };

  // Add new stock
  const addStock = async () => {
    const validation = await validateAction('add_stock', stocks.length);
    
    if (!validation.can_perform) {
      showUpgradePrompt(validation.message);
      return;
    }
    
    const newId = Math.max(...stocks.map(s => s.id)) + 1;
    const next = [...stocks, { id: newId, market: 'US', symbol: '' }];
    setStocks(next);
    validateStockDuplicates(next);
  };

  // Remove stock
  const removeStock = (id) => {
    if (stocks.length > 1) {
      const next = stocks.filter(stock => stock.id !== id);
      setStocks(next);
      validateStockDuplicates(next);
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    // console.log('🚀 handleSubmit called!');
    
    // Check if any strategy instances are enabled
    const enabledInstances = strategyInstances.filter(instance => instance.enabled);
    if (enabledInstances.length === 0) {
      alert('Please select at least one strategy to run the backtest.');
      return;
    }
    
    // Check if any timeframes are selected
    const selectedTimeframes = Object.keys(timeframes).filter(tf => timeframes[tf]).map(tf => parseInt(tf));
    if (selectedTimeframes.length === 0) {
              alert('Please select a timeframe to run the backtest.');
      return;
    }
    
    // Check if initial equity is valid
    if (!globalSettings.initialEquity || globalSettings.initialEquity <= 0) {
      alert('Please set a valid initial equity amount (minimum $1,000 recommended).');
      return;
    }
    
    setShowBacktestModal(true);
    setLoading(true);
    setError(null);
    setResults(null);
    setSelectedStrategyFilter('All');
    setSelectedStockStrategy(null);
    setAiAnalysis(null); // Clear any existing AI analysis
    setBacktestProgress(0);
    setBacktestStatus('Initializing backtest...');
    setActiveTab('stocks');
    setWorkspaceMode('results');

    // Scroll workspace into view
    if (workspaceTopRef.current) {
      workspaceTopRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    try {
      // Check network connectivity first
      if (!navigator.onLine) {
        throw new Error('No internet connection. Please check your network and try again.');
      }

      // console.log('=== FRONTEND DEBUG INFO ===');
          // console.log('Backend API URL:', backendApiUrl);
    // console.log('Making backtest request to:', `${backendApiUrl}/api/backtest/`);

      const selectedTimeframes = Object.keys(timeframes).filter(tf => timeframes[tf]).map(tf => parseInt(tf));
      const enabledInstances = strategyInstances.filter(instance => instance.enabled);
      const validStocks = stocks.filter(stock => stock.symbol.trim());

      // Map strategy names to backend format
      const strategyMapping = {
        'SMA-Crossover': 'sma_crossover',
        'RSI-Mean-Reversion': 'rsi_mean_reversion',
        'Advanced-Trend-Following': 'trend_following',
        'Adaptive-Strategy': 'adaptive',
        'Advanced-Mean-Reversion': 'mean_reversion',
        'VWAP-Strategy': 'vwap_strategy',
        'Hybrid-Leading/Lagging': 'hybrid_leading_lagging',
        'Renko-Streak': 'renko_streak'
      };

      const requestData = {
        initialEquity: globalSettings.initialEquity,
        slippage: globalSettings.slippage,
        brokerFee: globalSettings.brokerFee,
        staticStopLoss: globalSettings.stopLoss,
        distributeEquityEqually: globalSettings.distributeEquityEqually,
        timeframes: selectedTimeframes,
        strategyInstances: enabledInstances.map(instance => ({
          id: instance.id,
          name: instance.name,
          type: strategyMapping[instance.type] || instance.type,
          params: instance.params
        })),
        stocks: validStocks.map(stock => ({
          market: (stock.market || '').toLowerCase() === 'us' ? 'us' : (stock.market || '').toLowerCase(),
          ticker: stock.symbol
        }))
      };

              // console.log('Request data:', JSON.stringify(requestData, null, 2));
        // console.log('Strategy instances being sent:', requestData.strategyInstances);

      // Simulate progress
      const progressInterval = setInterval(() => {
        setBacktestProgress(prev => {
          if (prev >= 90) {
            clearInterval(progressInterval);
            return 90;
          }
          setBacktestStatus(`Processing ${Math.floor(prev / 10) + 1}/${selectedMaxYears} timeframes...`);
          return prev + 10;
        });
      }, 500);

      // Create a timeout promise for backtest (longer timeout since backtest is more intensive)
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => reject(new Error('Backtest request timeout - please check your internet connection')), 300000); // 5 minute timeout
      });

      // Create the fetch promise
      const fetchPromise = fetch(`${backendApiUrl}/api/backtest/`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(requestData)
      });

      // Race between fetch and timeout
      const response = await Promise.race([fetchPromise, timeoutPromise]);

      clearInterval(progressInterval);
      setBacktestProgress(100);
      setBacktestStatus('Finalizing results...');

              // console.log('Response received:', response);
        // console.log('Response status:', response.status);
        // console.log('Response ok:', response.ok);

      if (!response.ok) {
        if (response.status === 401) {
          // Authentication failed
          removeAuthToken();
          setIsAuthenticated(false);
          setUser(null);
          throw new Error('Authentication required. Please log in.');
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

              // console.log('Parsing response JSON...');
        const data = await response.json();
        console.log('🔍 DEBUG: Frontend received results:', data);
        
        // Check if different strategy instances have different results
        if (data && Object.keys(data).length > 0) {
          const firstTimeframe = Object.keys(data)[0];
          const timeframeData = data[firstTimeframe];
          if (timeframeData && timeframeData.data) {
            console.log('📊 DEBUG: Strategy instances in results:', timeframeData.data.map(metric => metric.metric === 'Strategy' ? Object.keys(metric).filter(k => k !== 'metric') : []).flat());
          }
        }

      setResults(data);
      setBacktestStatus('Backtest completed successfully!');
      setShowBacktestModal(false);
      setWorkspaceMode('results');
      
      // Check for failed stocks (notification will be shown in results header instead of toast)
      const allFailedStocks = new Set();
      Object.keys(data).forEach(timeframe => {
        const timeframeData = data[timeframe];
        if (timeframeData && timeframeData.failed_stocks) {
          timeframeData.failed_stocks.forEach(stock => allFailedStocks.add(stock));
        }
      });
      
      setTimeout(() => {
        if (workspaceTopRef.current) {
          workspaceTopRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 200);

    } catch (error) {
      console.error('Backtest error:', error);
      
      // Determine specific error message based on error type
      let errorMessage = 'Error running backtest';
      let errorType = 'error';
      
      if (error.message.includes('No internet connection')) {
        errorMessage = 'No internet connection. Please check your network and try again.';
        errorType = 'warning';
      } else if (error.message.includes('Backtest request timeout')) {
        errorMessage = 'Backtest request timed out. Please check your internet connection and try again.';
        errorType = 'warning';
      } else if (error.message.includes('Authentication required')) {
        errorMessage = 'Authentication required. Please log in again.';
        errorType = 'error';
      } else if (error.message.includes('Network') || error.message.includes('fetch') || error.message.includes('Failed to fetch')) {
        errorMessage = 'Network connection issue. Please check your internet connection and try again.';
        errorType = 'warning';
      } else {
        errorMessage = 'Error running backtest. Please check if the Python backend is running.';
        errorType = 'error';
      }
      
      // Show notification with specific error message
      setNotification({
        type: errorType,
        message: `📊 ${errorMessage}`,
        duration: 8000
      });
      
      setError(errorMessage);
      setBacktestStatus('Backtest failed');
      setShowBacktestModal(false);
    } finally {
      setLoading(false);
      setBacktestProgress(0);
    }
  };

  // Download Excel
  const downloadExcel = async () => {
    if (!results) return;

    // Check if user has access to Excel download
    const validation = await validateFeatureAccess('excel_download');
    if (!validation.canPerform) {
      showUpgradePrompt(validation.message);
      return;
    }

    try {
      // Check network connectivity first
      if (!navigator.onLine) {
        throw new Error('No internet connection. Please check your network and try again.');
      }

      // Create a timeout promise for Excel download
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => reject(new Error('Excel download timeout - please check your internet connection')), 60000); // 1 minute timeout
      });

      // Create the fetch promise
      const fetchPromise = fetch(`${backendApiUrl}/api/download-excel/`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({ results })
      });

      // Race between fetch and timeout
      const response = await Promise.race([fetchPromise, timeoutPromise]);

      if (!response.ok) {
        throw new Error('Failed to download Excel file');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'backtest_results.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Download error:', error);
      
      // Determine specific error message based on error type
      let errorMessage = 'Failed to download Excel file';
      let errorType = 'error';
      
      if (error.message.includes('No internet connection')) {
        errorMessage = 'No internet connection. Please check your network and try again.';
        errorType = 'warning';
      } else if (error.message.includes('Excel download timeout')) {
        errorMessage = 'Excel download timed out. Please check your internet connection and try again.';
        errorType = 'warning';
      } else if (error.message.includes('Network') || error.message.includes('fetch') || error.message.includes('Failed to fetch')) {
        errorMessage = 'Network connection issue. Please check your internet connection and try again.';
        errorType = 'warning';
      } else {
        errorMessage = 'Failed to download Excel file. Please try again.';
        errorType = 'error';
      }
      
      // Show notification with specific error message
      setNotification({
        type: errorType,
        message: `📥 ${errorMessage}`,
        duration: 8000
      });
    }
  };

  // AI Analysis
  // Function to calculate comprehensive summary for a stock-strategy across all timeframes
  const calculateStockStrategySummary = (ticker, strategy) => {
    const allTimeframeData = [];
    
    // Check if results is null or undefined
    if (!results) {
      return {
        top25Count: 0,
        avgMaxDrawdown: 0,
        medianMaxDrawdown: 0,
        maxDrawdownAllYears: 0,
        avgTotalReturn: 0,
        medianTotalReturn: 0,
        lowestTotalReturn: 0,
        avgWinRate: 0,
        avgCagr: 0,
        medianCagr: 0,
        lowestCagr: 0
      };
    }
    
    // Collect data from all timeframes
    Object.keys(results).forEach(timeframe => {
      const timeframeData = results[timeframe];
      if (timeframeData && timeframeData.data) {
        // Find the column key that matches the selected stock-strategy
        const strategyRow = timeframeData.data.find(row => row.metric === 'Strategy');
        if (strategyRow) {
          let stockStrategyKey = null;
          Object.keys(strategyRow).forEach(key => {
            if (key !== 'metric' && strategyRow[key] === strategy) {
              // Check if this column belongs to the selected ticker
              const equityRow = timeframeData.data.find(row => row.metric === 'Equity Name');
              if (equityRow && equityRow[key] === ticker) {
                stockStrategyKey = key;
              }
            }
          });
          
          if (stockStrategyKey && timeframeData.data[0] && timeframeData.data[0][stockStrategyKey] !== undefined) {
            const timeframeMetrics = {};
            timeframeData.data.forEach(row => {
              const value = row[stockStrategyKey];
              if (value !== undefined && value !== null) {
                timeframeMetrics[row.metric] = value;
              }
            });
            allTimeframeData.push(timeframeMetrics);
          }
        }
      }
    });
    
    if (allTimeframeData.length === 0) {
      return {
        top25Count: 0,
        avgMaxDrawdown: 0,
        medianMaxDrawdown: 0,
        maxDrawdownAllYears: 0,
        avgTotalReturn: 0,
        medianTotalReturn: 0,
        lowestTotalReturn: 0,
        avgWinRate: 0,
        avgCagr: 0,
        medianCagr: 0,
        lowestCagr: 0
      };
    }
    
    // Extract numeric values for calculations
    const totalReturns = allTimeframeData
      .map(data => data['Total Percentage Return'])
      .filter(val => val !== undefined && val !== null)
      .map(val => {
        const cleanVal = val.toString().replace(/[+%]/g, '');
        return parseFloat(cleanVal) || 0;
      });
    
    const maxDrawdowns = allTimeframeData
      .map(data => data['Maximum Drawdown'])
      .filter(val => val !== undefined && val !== null)
      .map(val => {
        const cleanVal = val.toString().replace(/[%]/g, '');
        return parseFloat(cleanVal) || 0;
      });
    
    const winRates = allTimeframeData
      .map(data => data['Winning Trades (%)'])
      .filter(val => val !== undefined && val !== null)
      .map(val => {
        const cleanVal = val.toString().replace(/[%]/g, '');
        return parseFloat(cleanVal) || 0;
      });
    
    const cagrs = allTimeframeData
      .map(data => data['CAGR'])
      .filter(val => val !== undefined && val !== null)
      .map(val => {
        const cleanVal = val.toString().replace(/[%]/g, '');
        return parseFloat(cleanVal) || 0;
      });
    
    // Calculate statistics
    const avgTotalReturn = totalReturns.length > 0 ? totalReturns.reduce((a, b) => a + b, 0) / totalReturns.length : 0;
    const medianTotalReturn = totalReturns.length > 0 ? totalReturns.sort((a, b) => a - b)[Math.floor(totalReturns.length / 2)] : 0;
    const lowestTotalReturn = totalReturns.length > 0 ? Math.min(...totalReturns) : 0;
    
    const avgMaxDrawdown = maxDrawdowns.length > 0 ? maxDrawdowns.reduce((a, b) => a + b, 0) / maxDrawdowns.length : 0;
    const medianMaxDrawdown = maxDrawdowns.length > 0 ? maxDrawdowns.sort((a, b) => a - b)[Math.floor(maxDrawdowns.length / 2)] : 0;
    const maxDrawdownAllYears = maxDrawdowns.length > 0 ? Math.max(...maxDrawdowns) : 0;
    
    const avgWinRate = winRates.length > 0 ? winRates.reduce((a, b) => a + b, 0) / winRates.length : 0;
    
    const avgCagr = cagrs.length > 0 ? cagrs.reduce((a, b) => a + b, 0) / cagrs.length : 0;
    const medianCagr = cagrs.length > 0 ? cagrs.sort((a, b) => a - b)[Math.floor(cagrs.length / 2)] : 0;
    const lowestCagr = cagrs.length > 0 ? Math.min(...cagrs) : 0;
    
    // Calculate top 25% count - identical to backend logic
    const yearlyMetrics = {};
    
    // Collect all metrics by timeframe (year)
    Object.keys(results).forEach(timeframe => {
      const timeframeData = results[timeframe];
      if (timeframeData && timeframeData.data) {
        const metrics = {};
        
        // Extract all metrics for this timeframe
        timeframeData.data.forEach(row => {
          if (row.metric === 'Total Percentage Return') {
            Object.keys(row).forEach(key => {
              if (key !== 'metric') {
                const value = row[key];
                if (value !== undefined && value !== null) {
                  const cleanVal = value.toString().replace(/[+%]/g, '');
                  const numericVal = parseFloat(cleanVal) || 0;
                  if (!metrics[key]) metrics[key] = {};
                  metrics[key].totalReturn = numericVal;
                }
              }
            });
          } else if (row.metric === 'Maximum Drawdown') {
            Object.keys(row).forEach(key => {
              if (key !== 'metric') {
                const value = row[key];
                if (value !== undefined && value !== null) {
                  const cleanVal = value.toString().replace(/[%]/g, '');
                  const numericVal = parseFloat(cleanVal) || 0;
                  if (!metrics[key]) metrics[key] = {};
                  metrics[key].maxDrawdown = numericVal;
                }
              }
            });
          } else if (row.metric === 'Winning Trades (%)') {
            Object.keys(row).forEach(key => {
              if (key !== 'metric') {
                const value = row[key];
                if (value !== undefined && value !== null) {
                  const cleanVal = value.toString().replace(/[%]/g, '');
                  const numericVal = parseFloat(cleanVal) || 0;
                  if (!metrics[key]) metrics[key] = {};
                  metrics[key].winningTrades = numericVal;
                }
              }
            });
          }
        });
        
        yearlyMetrics[timeframe] = metrics;
      }
    });
    
    // Calculate composite scores for each year (identical to backend)
    const top25Counts = {};
    
    Object.keys(yearlyMetrics).forEach(timeframe => {
      const yearMetrics = yearlyMetrics[timeframe];
      const stockStrategies = Object.keys(yearMetrics);
      
      if (stockStrategies.length < 2) return;
      
      // Extract values for normalization
      const returns = stockStrategies.map(ss => yearMetrics[ss].totalReturn || 0);
      const drawdowns = stockStrategies.map(ss => yearMetrics[ss].maxDrawdown || 0);
      const winningTrades = stockStrategies.map(ss => yearMetrics[ss].winningTrades || 0);
      
      const minReturn = Math.min(...returns);
      const maxReturn = Math.max(...returns);
      const minDrawdown = Math.min(...drawdowns);
      const maxDrawdown = Math.max(...drawdowns);
      const minWinningTrades = Math.min(...winningTrades);
      const maxWinningTrades = Math.max(...winningTrades);
      
      // Prevent division by zero
      const returnRange = maxReturn - minReturn || 1e-10;
      const drawdownRange = maxDrawdown - minDrawdown || 1e-10;
      const winningTradesRange = maxWinningTrades - minWinningTrades || 1e-10;
      
      // Calculate normalized scores for each stock-strategy
      const scores = {};
      stockStrategies.forEach(ss => {
        const normReturn = (yearMetrics[ss].totalReturn - minReturn) / returnRange;
        const normDrawdown = (maxDrawdown - yearMetrics[ss].maxDrawdown) / drawdownRange;
        const normWinningTrades = (yearMetrics[ss].winningTrades - minWinningTrades) / winningTradesRange;
        const score = 0.40 * normReturn + 0.40 * normDrawdown + 0.20 * normWinningTrades;
        scores[ss] = score;
      });
      
      // Calculate true 25th percentile threshold
      const scoreValues = Object.values(scores);
      const top25Threshold = Math.ceil(stockStrategies.length * 0.25);
      const sortedScores = scoreValues.sort((a, b) => b - a);
      const top25Score = sortedScores[top25Threshold - 1];
      
      // Count how many times each stock-strategy was in the top 25%
      stockStrategies.forEach(ss => {
        if (!top25Counts[ss]) top25Counts[ss] = 0;
        if (scores[ss] >= top25Score) {
          top25Counts[ss]++;
        }
      });
    });
    
    // Get the count for this specific stock-strategy
    // Find the column key that matches the selected stock-strategy
    let top25Count = 0;
    Object.keys(top25Counts).forEach(key => {
      // Check if this column key corresponds to the selected stock-strategy
      const strategyRow = results[Object.keys(results)[0]]?.data.find(row => row.metric === 'Strategy');
      const equityRow = results[Object.keys(results)[0]]?.data.find(row => row.metric === 'Equity Name');
      
      if (strategyRow && equityRow && 
          strategyRow[key] === strategy && 
          equityRow[key] === ticker) {
        top25Count = top25Counts[key] || 0;
      }
    });
    
    // Get the Total Return Across All Years from the most recent timeframe
    const mostRecentTimeframe = Object.keys(results).sort((a, b) => parseInt(b) - parseInt(a))[0];
          // console.log('🔍 Most recent timeframe:', mostRecentTimeframe);
      // console.log('🔍 All timeframes:', Object.keys(results));
    const mostRecentData = results[mostRecentTimeframe]?.data;
    let totalReturnAcrossYears = 0;
    
    if (mostRecentData) {
      // console.log('🔍 Available metrics in most recent data:', mostRecentData.map(row => row.metric));
      // console.log('🔍 Looking for metric containing "Total Return Across All Years"');
      const totalReturnMetrics = mostRecentData.filter(row => row.metric && row.metric.includes('Total Return'));
      // console.log('🔍 Found total return related metrics:', totalReturnMetrics.map(row => row.metric));
      const totalReturnRow = mostRecentData.find(row => row.metric === 'Total Return Across All Years (Sum of Independent Yearly Returns)') || 
                            mostRecentData.find(row => row.metric === 'Total Return Across All Years');
      // console.log('🔍 Found total return row:', totalReturnRow);
      
      if (totalReturnRow) {
        // Find the column key that matches the selected stock-strategy
        const strategyRow = mostRecentData.find(row => row.metric === 'Strategy');
        const equityRow = mostRecentData.find(row => row.metric === 'Equity Name');
        
        // console.log('🔍 Looking for ticker:', ticker, 'strategy:', strategy);
        // console.log('🔍 Strategy row keys:', strategyRow ? Object.keys(strategyRow) : 'No strategy row');
        // console.log('🔍 Equity row keys:', equityRow ? Object.keys(equityRow) : 'No equity row');
        
        if (strategyRow && equityRow) {
          let found = false;
          Object.keys(totalReturnRow).forEach(key => {
            if (key !== 'metric') {
              // console.log(`🔍 Checking key: ${key}, strategy: ${strategyRow[key]}, equity: ${equityRow[key]}`);
              if (strategyRow[key] === strategy && equityRow[key] === ticker) {
                const value = totalReturnRow[key];
                // console.log(`🔍 Found match! Value: ${value}`);
                const cleanVal = value.toString().replace(/[+%]/g, '');
                totalReturnAcrossYears = parseFloat(cleanVal) || 0;
                found = true;
              }
            }
          });
          
          if (!found) {
            // console.log('❌ No matching stock-strategy combination found');
            // console.log('🔍 Available combinations:');
            // Object.keys(totalReturnRow).forEach(key => {
            //   if (key !== 'metric') {
            //     console.log(`  ${key}: ${equityRow[key]} - ${strategyRow[key]}`);
            //   }
            // });
          }
        } else {
          // console.log('❌ Missing strategy or equity row');
        }
      } else {
        // console.log('❌ Total return row not found');
      }
    }
    
    return {
      top25Count,
      avgMaxDrawdown,
      medianMaxDrawdown,
      maxDrawdownAllYears,
      avgTotalReturn,
      medianTotalReturn,
      lowestTotalReturn,
      avgWinRate,
      avgCagr,
      medianCagr,
      lowestCagr,
      totalReturnAcrossYears
    };
  };

  const extractPerTimeframeMetrics = (ticker, strategy) => {
    if (!results) return [];
    return Object.keys(results)
      .map((tf) => parseInt(tf, 10))
      .filter((n) => !Number.isNaN(n))
      .sort((a, b) => a - b)
      .map((tf) => {
        const tfKey = String(tf);
        const timeframeData = results[tfKey];
        if (!timeframeData?.data) return null;
        const strategyRow = timeframeData.data.find((row) => row.metric === 'Strategy');
        const equityRow = timeframeData.data.find((row) => row.metric === 'Equity Name');
        let colKey = null;
        if (strategyRow && equityRow) {
          Object.keys(strategyRow).forEach((key) => {
            if (key !== 'metric' && strategyRow[key] === strategy && equityRow[key] === ticker) {
              colKey = key;
            }
          });
        }
        if (!colKey) return null;
        const pick = (metric) => {
          const row = timeframeData.data.find((r) => r.metric === metric);
          return row ? row[colKey] : null;
        };
        return {
          timeframe: tfKey,
          totalReturn: parsePercentMetric(pick('Total Percentage Return')),
          cagr: parsePercentMetric(pick('CAGR')),
          maxDrawdown: parsePercentMetric(pick('Maximum Drawdown')),
          winRate: parsePercentMetric(pick('Winning Trades (%)')),
          absoluteGrowth: parsePercentMetric(pick('Absolute Stock Growth (%)')),
        };
      })
      .filter(Boolean);
  };

  const buildPaperBacktestSnapshot = (ticker, strategy, cardMetrics) => {
    if (!results) return null;
    const instance = findStrategyInstanceByName(strategy);
    const enabledInstances = strategyInstances.filter((i) => i.enabled);
    const validStocks = stocks.filter((s) => s.symbol.trim());
    const summary = calculateStockStrategySummary(ticker, strategy);
    const activeTimeframes = Object.keys(timeframes).filter((tf) => timeframes[tf]).map(String);

    return {
      name: `Paper: ${ticker} — ${strategy} (${new Date().toLocaleDateString('en-US')})`,
      stocks: validStocks.map((s) => s.symbol).join(', '),
      strategies: enabledInstances.map((inst) => ({
        id: inst.id,
        name: inst.name,
        type: inst.type,
        params: inst.params,
      })),
      initial_equity: globalSettings.initialEquity,
      slippage: globalSettings.slippage,
      broker_fee: globalSettings.brokerFee,
      stop_loss: globalSettings.stopLoss,
      distribute_equity: globalSettings.distributeEquityEqually,
      display_summary: {
        ticker,
        strategy,
        subscribed_at: new Date().toISOString(),
        selected_max_years: selectedMaxYears,
        timeframes_tested: activeTimeframes,
        card_metrics: {
          totalReturnAcrossYears: cardMetrics?.totalReturnAcrossYears ?? null,
          avgTotalReturn: cardMetrics?.avgTotalReturn ?? null,
          avgCagr: cardMetrics?.avgCagr ?? null,
          avgWinRate: cardMetrics?.avgWinRate ?? null,
          avgMaxDrawdown: cardMetrics?.avgMaxDrawdown ?? null,
        },
        detailed_summary: summary,
        per_timeframe: extractPerTimeframeMetrics(ticker, strategy),
        strategy_params: instance?.params || {},
        global_settings: {
          initialEquity: globalSettings.initialEquity,
          slippage: globalSettings.slippage,
          brokerFee: globalSettings.brokerFee,
          stopLoss: globalSettings.stopLoss,
          distributeEquityEqually: globalSettings.distributeEquityEqually,
        },
      },
    };
  };

  const renderPaperSnapshotPanel = (sub) => {
    const snapshot = sub.source_backtest?.snapshot_summary;
    if (!snapshot) {
      return (
        <div className="paper-snapshot-panel">
          <p className="paper-snapshot-empty">No backtest snapshot saved for this subscription.</p>
        </div>
      );
    }

    const card = snapshot.card_metrics || {};
    const perTf = snapshot.per_timeframe || [];
    const params = snapshot.strategy_params || {};

    return (
      <div className="paper-snapshot-panel">
        <h4 className="paper-trade-book-title">Backtest at subscribe</h4>
        <p className="paper-snapshot-meta">
          Saved {sub.source_backtest?.created_at
            ? new Date(sub.source_backtest.created_at).toLocaleString()
            : '—'}
          {snapshot.selected_max_years ? ` · ${snapshot.selected_max_years}Y run` : ''}
          {snapshot.timeframes_tested?.length
            ? ` · Years ${snapshot.timeframes_tested.join(', ')}`
            : ''}
        </p>

        <div className="paper-snapshot-metrics">
          <div className="paper-metric">
            <span className="paper-metric-label">Total return (all years)</span>
            <span className={`paper-metric-value ${(card.totalReturnAcrossYears || 0) >= 0 ? 'positive' : 'negative'}`}>
              {card.totalReturnAcrossYears != null
                ? `${card.totalReturnAcrossYears >= 0 ? '+' : ''}${Number(card.totalReturnAcrossYears).toFixed(1)}%`
                : '—'}
            </span>
          </div>
          <div className="paper-metric">
            <span className="paper-metric-label">Avg return / year</span>
            <span className={`paper-metric-value ${(card.avgTotalReturn || 0) >= 0 ? 'positive' : 'negative'}`}>
              {card.avgTotalReturn != null
                ? `${card.avgTotalReturn >= 0 ? '+' : ''}${Number(card.avgTotalReturn).toFixed(1)}%`
                : '—'}
            </span>
          </div>
          <div className="paper-metric">
            <span className="paper-metric-label">Avg CAGR</span>
            <span className="paper-metric-value">
              {card.avgCagr != null ? `${Number(card.avgCagr).toFixed(1)}%` : '—'}
            </span>
          </div>
          <div className="paper-metric">
            <span className="paper-metric-label">Avg win rate</span>
            <span className="paper-metric-value">
              {card.avgWinRate != null ? `${Number(card.avgWinRate).toFixed(1)}%` : '—'}
            </span>
          </div>
          <div className="paper-metric">
            <span className="paper-metric-label">Avg max drawdown</span>
            <span className="paper-metric-value negative">
              {card.avgMaxDrawdown != null ? `${Number(card.avgMaxDrawdown).toFixed(1)}%` : '—'}
            </span>
          </div>
        </div>

        {perTf.length > 0 && (
          <table className="paper-trade-table paper-snapshot-table">
            <thead>
              <tr>
                <th>Year</th>
                <th>Return</th>
                <th>CAGR</th>
                <th>Max DD</th>
                <th>Win %</th>
                <th>B&amp;H</th>
              </tr>
            </thead>
            <tbody>
              {perTf.map((row) => (
                <tr key={row.timeframe}>
                  <td>{row.timeframe}Y</td>
                  <td className={(row.totalReturn || 0) >= 0 ? 'positive' : 'negative'}>
                    {row.totalReturn != null ? `${row.totalReturn >= 0 ? '+' : ''}${row.totalReturn.toFixed(1)}%` : '—'}
                  </td>
                  <td>{row.cagr != null ? `${row.cagr.toFixed(1)}%` : '—'}</td>
                  <td className="negative">{row.maxDrawdown != null ? `${row.maxDrawdown.toFixed(1)}%` : '—'}</td>
                  <td>{row.winRate != null ? `${row.winRate.toFixed(1)}%` : '—'}</td>
                  <td>{row.absoluteGrowth != null ? `${row.absoluteGrowth.toFixed(1)}%` : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {Object.keys(params).length > 0 && (
          <div className="paper-params-preview">
            {Object.entries(params).map(([key, value]) => (
              <span key={key} className="paper-param-chip">{key}: {String(value)}</span>
            ))}
          </div>
        )}
      </div>
    );
  };

  // Function to calculate composite scores for sorting
  const calculateCompositeScores = (data) => {
    const scores = {};
    const stockStrategies = {};
    
    // Extract stock-strategy data and calculate scores
    data.forEach(row => {
      if (row.metric === 'Equity Name') {
        Object.keys(row).forEach(key => {
          if (key !== 'metric') {
            stockStrategies[key] = { 
              ticker: row[key],
              strategy: standardizeStrategyName(key.split('_').slice(1).join('_')) || 'Unknown Strategy'
            };
          }
        });
      } else if (row.metric === 'Strategy') {
        Object.keys(row).forEach(key => {
          if (key !== 'metric' && stockStrategies[key]) {
            stockStrategies[key].strategy = row[key];
          }
        });
      }
    });
    
    // Extract values for normalization
    const returns = [];
    const drawdowns = [];
    const winningTrades = [];
    
    data.forEach(row => {
      if (row.metric === 'Total Percentage Return') {
        Object.keys(row).forEach(key => {
          if (key !== 'metric') {
            const value = row[key];
            const numericValue = parseFloat(value.replace(/[+%]/g, ''));
            returns.push(isNaN(numericValue) ? 0 : numericValue);
          }
        });
      } else if (row.metric === 'Maximum Drawdown') {
        Object.keys(row).forEach(key => {
          if (key !== 'metric') {
            const value = row[key];
            const numericValue = parseFloat(value.replace(/[%]/g, ''));
            drawdowns.push(isNaN(numericValue) ? 0 : numericValue);
          }
        });
      } else if (row.metric === 'Winning Trades (%)') {
        Object.keys(row).forEach(key => {
          if (key !== 'metric') {
            const value = row[key];
            const numericValue = parseFloat(value.replace(/[%]/g, ''));
            winningTrades.push(isNaN(numericValue) ? 0 : numericValue);
          }
        });
      }
    });
    
    // Calculate normalization ranges
    const minReturn = Math.min(...returns);
    const maxReturn = Math.max(...returns);
    const minDrawdown = Math.min(...drawdowns);
    const maxDrawdown = Math.max(...drawdowns);
    const minWinningTrades = Math.min(...winningTrades);
    const maxWinningTrades = Math.max(...winningTrades);
    
    // Prevent division by zero
    const returnRange = maxReturn - minReturn || 1e-10;
    const drawdownRange = maxDrawdown - minDrawdown || 1e-10;
    const winningTradesRange = maxWinningTrades - minWinningTrades || 1e-10;
    
    // Calculate scores for each stock-strategy
    Object.keys(stockStrategies).forEach(key => {
      const returnRow = data.find(row => row.metric === 'Total Percentage Return');
      const drawdownRow = data.find(row => row.metric === 'Maximum Drawdown');
      const winningTradesRow = data.find(row => row.metric === 'Winning Trades (%)');
      
      if (returnRow && drawdownRow && winningTradesRow) {
        const returnValue = parseFloat(returnRow[key].replace(/[+%]/g, '')) || 0;
        const drawdownValue = parseFloat(drawdownRow[key].replace(/[%]/g, '')) || 0;
        const winningTradesValue = parseFloat(winningTradesRow[key].replace(/[%]/g, '')) || 0;
        
        const normReturn = (returnValue - minReturn) / returnRange;
        const normDrawdown = (maxDrawdown - drawdownValue) / drawdownRange;
        const normWinningTrades = (winningTradesValue - minWinningTrades) / winningTradesRange;
        
        const score = 0.40 * normReturn + 0.40 * normDrawdown + 0.20 * normWinningTrades;
        scores[key] = score;
      }
    });
    
    return { scores, stockStrategies };
  };

  // Function to process backend data for the new UI layout
  const processResultsData = (data) => {
    const stockStrategies = [];
    const stockStrategyData = {};
    
    // Extract stock-strategy data from the backend format
    data.forEach(row => {
      if (row.metric === 'Equity Name') {
        Object.keys(row).forEach(key => {
          if (key !== 'metric') {
            stockStrategyData[key] = { 
              ticker: row[key],
              strategy: standardizeStrategyName(key.split('_').slice(1).join('_')) || 'Unknown Strategy'
            };
          }
        });
      } else if (row.metric === 'Strategy') {
        Object.keys(row).forEach(key => {
          if (key !== 'metric' && stockStrategyData[key]) {
            stockStrategyData[key].strategy = row[key];
          }
        });
      } else if (row.metric === 'Total Percentage Return') {
        Object.keys(row).forEach(key => {
          if (key !== 'metric' && stockStrategyData[key]) {
            const value = row[key];
            const numericValue = parseFloat(value.replace(/[+%]/g, ''));
            stockStrategyData[key].totalReturn = isNaN(numericValue) ? 0 : numericValue;
          }
        });
      } else if (row.metric === 'Winning Trades (%)') {
        Object.keys(row).forEach(key => {
          if (key !== 'metric' && stockStrategyData[key]) {
            const value = row[key];
            const numericValue = parseFloat(value.replace(/[%]/g, ''));
            stockStrategyData[key].winRate = isNaN(numericValue) ? 0 : numericValue;
          }
        });
      } else if (row.metric === 'CAGR') {
        Object.keys(row).forEach(key => {
          if (key !== 'metric' && stockStrategyData[key]) {
            const value = row[key];
            const numericValue = parseFloat(value.replace(/[%]/g, ''));
            stockStrategyData[key].cagr = isNaN(numericValue) ? 0 : numericValue;
          }
        });
      } else if (row.metric === 'Maximum Drawdown') {
        Object.keys(row).forEach(key => {
          if (key !== 'metric' && stockStrategyData[key]) {
            const value = row[key];
            const numericValue = parseFloat(value.replace(/[%]/g, ''));
            stockStrategyData[key].maxDrawdown = isNaN(numericValue) ? 0 : numericValue;
          }
        });
      } else if (row.metric === 'Total Return Across All Years (Sum of Independent Yearly Returns)') {
        // console.log('🔍 Found Total Return Across All Years metric:', row);
        Object.keys(row).forEach(key => {
          if (key !== 'metric' && stockStrategyData[key]) {
            const value = row[key];
            const numericValue = parseFloat(value.replace(/[+%]/g, ''));
            stockStrategyData[key].totalReturnAcrossYears = isNaN(numericValue) ? 0 : numericValue;
            // console.log(`🔍 ${key}: ${value} -> ${stockStrategyData[key].totalReturnAcrossYears}`);
          }
        });
      } else if (row.metric === 'Absolute Stock Growth (%)') {
        Object.keys(row).forEach(key => {
          if (key !== 'metric' && stockStrategyData[key]) {
            stockStrategyData[key].absoluteGrowth = parsePercentMetric(row[key]);
          }
        });
      } else if (row.metric === 'Initial Equity') {
        Object.keys(row).forEach(key => {
          if (key !== 'metric' && stockStrategyData[key]) {
            stockStrategyData[key].initialEquity = parseCurrencyMetric(row[key]);
          }
        });
      } else if (row.metric === 'Final Equity') {
        Object.keys(row).forEach(key => {
          if (key !== 'metric' && stockStrategyData[key]) {
            stockStrategyData[key].finalEquity = parseCurrencyMetric(row[key]);
          }
        });
      }
    });
    
    // Convert to array format
    Object.keys(stockStrategyData).forEach(key => {
      if (stockStrategyData[key].ticker) {
        stockStrategies.push({
          id: key,
          ticker: stockStrategyData[key].ticker,
          strategy: stockStrategyData[key].strategy,
          totalReturn: stockStrategyData[key].totalReturn || 0,
          winRate: stockStrategyData[key].winRate || 0,
          cagr: stockStrategyData[key].cagr || 0,
          maxDrawdown: stockStrategyData[key].maxDrawdown || 0,
          totalReturnAcrossYears: stockStrategyData[key].totalReturnAcrossYears || 0,
          absoluteGrowth: stockStrategyData[key].absoluteGrowth ?? null,
          initialEquity: stockStrategyData[key].initialEquity ?? null,
          finalEquity: stockStrategyData[key].finalEquity ?? null
        });
      }
    });
    
    // Calculate overall performance metrics
    const avgReturn = stockStrategies.length > 0 ? stockStrategies.reduce((sum, ss) => sum + ss.totalReturn, 0) / stockStrategies.length : 0;
    const overallWinRate = stockStrategies.length > 0 ? stockStrategies.reduce((sum, ss) => sum + ss.winRate, 0) / stockStrategies.length : 0;
    const overallCagr = stockStrategies.length > 0 ? stockStrategies.reduce((sum, ss) => sum + ss.cagr, 0) / stockStrategies.length : 0;
    const maxDrawdown = stockStrategies.length > 0 ? Math.max(...stockStrategies.map(ss => ss.maxDrawdown)) : 0;
    const totalReturnAcrossYears = stockStrategies.length > 0 ? stockStrategies[0].totalReturnAcrossYears : 0; // Use first one since all should be same
    
    return {
      stockStrategies,
      avgReturn,
      maxDrawdown,
      overallWinRate,
      overallCagr,
      totalReturnAcrossYears
    };
  };

  const analyzeResults = async () => {
    if (!results) return;

    // Check if user has access to AI analysis
    const validation = await validateFeatureAccess('ai_analysis');
    if (!validation.canPerform) {
      showUpgradePrompt(validation.message);
      return;
    }

    setShowAiModal(false);
    setAiLoading(true);
    setAiAnalysis(null);
    setAiProgress(0);
    setSelectedStockStrategy(null); // Always clear selection
    setAiStatus('Initializing comprehensive AI analysis for all combinations...');
    setActiveTab('stocks');
    setWorkspaceMode('ai');

    if (workspaceTopRef.current) {
      workspaceTopRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    try {
      // Check network connectivity first
      if (!navigator.onLine) {
        throw new Error('No internet connection. Please check your network and try again.');
      }

      // Simulate progress
      const progressInterval = setInterval(() => {
        setAiProgress(prev => {
          if (prev >= 90) {
            clearInterval(progressInterval);
            return 90;
          }
        const currentAspect = Math.floor(prev / 15) + 1;
        setAiStatus(`Analyzing all combinations - ${currentAspect}/6 aspects...`);
          return prev + 15;
        });
      }, 800);

      // Prepare data for AI analysis based on selection context
      let summaryData = [];
      let analysisContext = 'comprehensive';
      
      // Add calculation methodology explanation for AI
      const calculationMethodology = {
        timeframe_approach: "Each backtest is divided into independent timeframe slices (1Y, 2Y, 3Y, etc.). Each timeframe represents exactly one year of data.",
        position_management: "At the end of each timeframe, all open positions are closed. Positions that were open at the end of a timeframe are immediately re-opened at the start of the next timeframe (called 'Immediate Re-entry') to simulate continuous market exposure.",
        equity_inheritance: "The initial equity for each timeframe is the final equity (total portfolio value) from the previous timeframe. This creates a continuous compounding effect across timeframes.",
        metric_calculations: {
          total_return: "Total Return Across All Years = Sum of all individual timeframe profits/losses divided by the original initial equity from the oldest timeframe.",
          avg_metrics: "Average metrics (Avg Total Return, Avg CAGR, Avg Win Rate, etc.) are calculated by summing individual timeframe values and dividing by the number of timeframes.",
          cagr: "CAGR (Compound Annual Growth Rate) is calculated per timeframe using actual holding periods, not total time periods. Formula: ((Final Portfolio Value / Initial Equity) ^ (1 / Actual Holding Years) - 1) * 100",
          timeframe_cagr: "Each timeframe's CAGR uses that timeframe's initial equity and final portfolio value, with the holding period being the actual time money was invested within that timeframe.",
          final_equity: "Final Equity = Initial Equity + Total Profit/Loss for that timeframe. For open positions at timeframe end, their current value is included in final portfolio value."
        },
        data_structure: "Each stock-strategy combination is tested across all selected timeframes, with metrics calculated independently for each timeframe slice."
      };
      
      // Get all available timeframes
      const timeframes = results ? Object.keys(results).sort((a, b) => parseInt(a) - parseInt(b)) : [];
      
      if (timeframes.length === 0) {
        throw new Error('No results data available for analysis');
      }
      
          // console.log('Processing AI analysis for timeframes:', timeframes);
    // console.log('Selected stock-strategy:', selectedStockStrategy);
      
        // Comprehensive analysis of all stock-strategies
        analysisContext = 'comprehensive';
        // console.log('Performing comprehensive analysis of all stock-strategies');
        
        // Collect all stock-strategy data from all timeframes
        const allStockStrategyData = {};
        
        timeframes.forEach(timeframe => {
          const timeframeData = results[timeframe];
          if (timeframeData && timeframeData.data) {
            // Extract metrics for each stock-strategy in this timeframe
            timeframeData.data.forEach(row => {
              if (row.metric === 'Equity Name') {
                Object.keys(row).forEach(key => {
                  if (key !== 'metric') {
                    const stockName = row[key];
                    if (!allStockStrategyData[key]) {
                      allStockStrategyData[key] = {
                        equity: stockName,
                        strategy: '',
                        timeframes: {},
                        metrics: {}
                      };
                    }
                  }
                });
              } else if (row.metric === 'Strategy') {
                Object.keys(row).forEach(key => {
                  if (key !== 'metric' && allStockStrategyData[key]) {
                    allStockStrategyData[key].strategy = row[key];
                  }
                });
              } else {
                // Store all other metrics
                Object.keys(row).forEach(key => {
                  if (key !== 'metric' && allStockStrategyData[key]) {
                    if (!allStockStrategyData[key].timeframes[timeframe]) {
                      allStockStrategyData[key].timeframes[timeframe] = {};
                    }
                    allStockStrategyData[key].timeframes[timeframe][row.metric] = row[key];
                  }
                });
              }
            });
          }
        });
        
        // Convert to summary data format for AI
        Object.keys(allStockStrategyData).forEach(stockStrategyKey => {
          const data = allStockStrategyData[stockStrategyKey];
          const timeframesData = data.timeframes;
          
          // Calculate aggregated metrics across all timeframes
          const totalReturns = [];
          const cagrs = [];
          const maxDrawdowns = [];
          const winningTrades = [];
          
          Object.keys(timeframesData).forEach(timeframe => {
            const timeframeData = timeframesData[timeframe];
            
            // Extract Total Percentage Return
            if (timeframeData['Total Percentage Return']) {
              const returnStr = timeframeData['Total Percentage Return'].toString();
              const cleanReturn = returnStr.replace(/[+%]/g, '');
              const returnVal = parseFloat(cleanReturn) || 0;
              totalReturns.push(returnVal);
            }
            
            // Extract CAGR
            if (timeframeData['CAGR']) {
              const cagrStr = timeframeData['CAGR'].toString();
              const cleanCagr = cagrStr.replace(/[+%]/g, '');
              const cagrVal = parseFloat(cleanCagr) || 0;
              cagrs.push(cagrVal);
            }
            
            // Extract Maximum Drawdown
            if (timeframeData['Maximum Drawdown']) {
              const drawdownStr = timeframeData['Maximum Drawdown'].toString();
              const cleanDrawdown = drawdownStr.replace(/[%]/g, '');
              const drawdownVal = parseFloat(cleanDrawdown) || 0;
              maxDrawdowns.push(drawdownVal);
            }
            
            // Extract Winning Trades
            if (timeframeData['Winning Trades (%)']) {
              const winStr = timeframeData['Winning Trades (%)'].toString();
              const cleanWin = winStr.replace(/[%]/g, '');
              const winVal = parseFloat(cleanWin) || 0;
              winningTrades.push(winVal);
            }
          });
          
          // Calculate summary statistics
          const avgTotalReturn = totalReturns.length > 0 ? totalReturns.reduce((a, b) => a + b, 0) / totalReturns.length : 0;
          const medianTotalReturn = totalReturns.length > 0 ? totalReturns.sort((a, b) => a - b)[Math.floor(totalReturns.length / 2)] : 0;
          const minTotalReturn = totalReturns.length > 0 ? Math.min(...totalReturns) : 0;
          
          const avgCagr = cagrs.length > 0 ? cagrs.reduce((a, b) => a + b, 0) / cagrs.length : 0;
          const medianCagr = cagrs.length > 0 ? cagrs.sort((a, b) => a - b)[Math.floor(cagrs.length / 2)] : 0;
          const minCagr = cagrs.length > 0 ? Math.min(...cagrs) : 0;
          
          const avgMaxDrawdown = maxDrawdowns.length > 0 ? maxDrawdowns.reduce((a, b) => a + b, 0) / maxDrawdowns.length : 0;
          const avgWinningTrades = winningTrades.length > 0 ? winningTrades.reduce((a, b) => a + b, 0) / winningTrades.length : 0;
          
          // Calculate top 25% count using the same logic as before
          const yearlyMetrics = {};
          Object.keys(results).forEach(timeframe => {
            const timeframeData = results[timeframe];
            if (timeframeData && timeframeData.data) {
              const metrics = {};
              timeframeData.data.forEach(row => {
                if (row.metric === 'Total Percentage Return') {
                  Object.keys(row).forEach(key => {
                    if (key !== 'metric') {
                      const value = row[key];
                      if (value !== undefined && value !== null) {
                        const cleanVal = value.toString().replace(/[+%]/g, '');
                        const numericVal = parseFloat(cleanVal) || 0;
                        if (!metrics[key]) metrics[key] = {};
                        metrics[key].totalReturn = numericVal;
                      }
                    }
                  });
                } else if (row.metric === 'Maximum Drawdown') {
                  Object.keys(row).forEach(key => {
                    if (key !== 'metric') {
                      const value = row[key];
                      if (value !== undefined && value !== null) {
                        const cleanVal = value.toString().replace(/[%]/g, '');
                        const numericVal = parseFloat(cleanVal) || 0;
                        if (!metrics[key]) metrics[key] = {};
                        metrics[key].maxDrawdown = numericVal;
                      }
                    }
                  });
                } else if (row.metric === 'Winning Trades (%)') {
                  Object.keys(row).forEach(key => {
                    if (key !== 'metric') {
                      const value = row[key];
                      if (value !== undefined && value !== null) {
                        const cleanVal = value.toString().replace(/[%]/g, '');
                        const numericVal = parseFloat(cleanVal) || 0;
                        if (!metrics[key]) metrics[key] = {};
                        metrics[key].winningTrades = numericVal;
                      }
                    }
                  });
                }
              });
              yearlyMetrics[timeframe] = metrics;
            }
          });
          
          const top25Counts = {};
          Object.keys(yearlyMetrics).forEach(timeframe => {
            const yearMetrics = yearlyMetrics[timeframe];
            const stockStrategies = Object.keys(yearMetrics);
            
            if (stockStrategies.length < 2) return;
            
            const returns = stockStrategies.map(ss => yearMetrics[ss].totalReturn || 0);
            const drawdowns = stockStrategies.map(ss => yearMetrics[ss].maxDrawdown || 0);
            const winningTrades = stockStrategies.map(ss => yearMetrics[ss].winningTrades || 0);
            
            const minReturn = Math.min(...returns);
            const maxReturn = Math.max(...returns);
            const minDrawdown = Math.min(...drawdowns);
            const maxDrawdown = Math.max(...drawdowns);
            const minWinningTrades = Math.min(...winningTrades);
            const maxWinningTrades = Math.max(...winningTrades);
            
            const returnRange = maxReturn - minReturn || 1e-10;
            const drawdownRange = maxDrawdown - minDrawdown || 1e-10;
            const winningTradesRange = maxWinningTrades - minWinningTrades || 1e-10;
            
            const scores = {};
            stockStrategies.forEach(ss => {
              const normReturn = (yearMetrics[ss].totalReturn - minReturn) / returnRange;
              const normDrawdown = (maxDrawdown - yearMetrics[ss].maxDrawdown) / drawdownRange;
              const normWinningTrades = (yearMetrics[ss].winningTrades - minWinningTrades) / winningTradesRange;
              const score = 0.40 * normReturn + 0.40 * normDrawdown + 0.20 * normWinningTrades;
              scores[ss] = score;
            });
            
            const scoreValues = Object.values(scores);
            scoreValues.sort((a, b) => a - b);
            const threshold = scoreValues.length > 0 ? 
              scoreValues[Math.floor(scoreValues.length * 0.75)] : 0;
            
            stockStrategies.forEach(ss => {
              if (!top25Counts[ss]) top25Counts[ss] = 0;
              if (scores[ss] >= threshold) {
                top25Counts[ss]++;
              }
            });
          });
          
          const top25Count = top25Counts[stockStrategyKey] || 0;
          
          // Collect all detailed metrics for this stock-strategy across all timeframes
          const detailedMetrics = {};
          Object.keys(timeframesData).forEach(timeframe => {
            const timeframeData = timeframesData[timeframe];
            detailedMetrics[timeframe] = timeframeData;
          });
          
          summaryData.push({
            equity: data.equity,
            strategy: data.strategy,
            top25Count: top25Count,
            avgTotalReturn: avgTotalReturn,
            medianTotalReturn: medianTotalReturn,
            minTotalReturn: minTotalReturn,
            avgCagr: avgCagr,
            medianCagr: medianCagr,
            minCagr: minCagr,
            avgMaxDrawdown: avgMaxDrawdown,
            avgWinningTrades: avgWinningTrades,
            detailedMetrics: detailedMetrics, // Include all detailed metrics
            timeframePerformance: Object.keys(timeframesData).map(timeframe => ({
              timeframe: timeframe,
              totalReturn: timeframesData[timeframe]['Total Percentage Return'] || 'N/A',
              cagr: timeframesData[timeframe]['CAGR'] || 'N/A',
              maxDrawdown: timeframesData[timeframe]['Maximum Drawdown'] || 'N/A',
              winningTrades: timeframesData[timeframe]['Winning Trades (%)'] || 'N/A',
              initialEquity: timeframesData[timeframe]['Initial Equity'] || 'N/A',
              totalProfitLoss: timeframesData[timeframe]['Total Profit/Loss'] || 'N/A',
              finalEquity: timeframesData[timeframe]['Final Equity'] || 'N/A',
              absoluteGrowth: timeframesData[timeframe]['Absolute Stock Growth (%)'] || 'N/A',
              maxTradeDrawdown: timeframesData[timeframe]['Maximum Trade Drawdown (%)'] || 'N/A',
              numberOfTrades: timeframesData[timeframe]['Number of Trades'] || 'N/A',
              avgHoldingPeriod: timeframesData[timeframe]['Average Holding Period (Days)'] || 'N/A',
              cagrPeriod: timeframesData[timeframe]['CAGR Period (Total Holding Period in Years)'] || 'N/A',
              slippage: timeframesData[timeframe]['Slippage Percentage'] || 'N/A',
              flatFee: timeframesData[timeframe]['Flat Fee per Trade'] || 'N/A',
              stopLoss: timeframesData[timeframe]['Stop Loss'] || 'N/A'
            }))
          });
        });
      
      if (summaryData.length === 0) {
        throw new Error('No valid summary data could be generated for analysis');
      }

              // console.log('Sending AI analysis data:', summaryData);
        // console.log('Summary data length:', summaryData.length);
        // console.log('Available timeframes:', timeframes);
      
      // Create a timeout promise
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => reject(new Error('Request timeout - please check your internet connection')), 120000); // 2 minute timeout
      });

      // Create the fetch promise
      const fetchPromise = fetch(`${backendApiUrl}/api/analyze-results/`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({ 
          summaryData, 
          analysisContext, 
          calculationMethodology 
        })
      });

      // Race between fetch and timeout
      const response = await Promise.race([fetchPromise, timeoutPromise]);

      clearInterval(progressInterval);
      setAiProgress(100);
      setAiStatus('Finalizing comprehensive analysis...');

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        const errorMessage = errorData.details || errorData.error || 'Failed to analyze results';
        throw new Error(errorMessage);
      }

      const analysis = await response.json();
              // console.log('AI Analysis received:', analysis);
        // console.log('Analysis keys:', Object.keys(analysis));
        // console.log('Summary:', analysis.summary);
        // console.log('Top recommendations:', analysis.top_recommendations);
        // console.log('Risk assessment:', analysis.risk_assessment);
        // console.log('Strategy insights:', analysis.strategy_insights);
        // console.log('Actionable advice:', analysis.actionable_advice);
      setAiAnalysis(analysis);
      setAiStatus('Comprehensive analysis completed!');
      setShowAiModal(false);
      setWorkspaceMode('ai');

      setTimeout(() => {
        if (aiAnalysisRef.current) {
          aiAnalysisRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else if (workspaceTopRef.current) {
          workspaceTopRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 200);

    } catch (error) {
      console.error('AI Analysis error:', error);
      console.error('Error details:', error.message);
      
      // Determine specific error message based on error type
      let errorMessage = 'AI Analysis failed';
      let errorType = 'error';
      
      if (error.message.includes('No internet connection')) {
        errorMessage = 'No internet connection. Please check your network and try again.';
        errorType = 'warning';
      } else if (error.message.includes('Request timeout')) {
        errorMessage = 'Request timed out. Please check your internet connection and try again.';
        errorType = 'warning';
      } else if (error.message.includes('No valid summary data')) {
        errorMessage = 'No valid data available for AI analysis. Please ensure you have successful backtest results.';
        errorType = 'warning';
      } else if (error.message.includes('Failed to analyze results')) {
        errorMessage = 'AI service temporarily unavailable. Please try again in a few minutes.';
        errorType = 'warning';
      } else if (error.message.includes('Network') || error.message.includes('fetch') || error.message.includes('Failed to fetch')) {
        errorMessage = 'Network connection issue. Please check your internet connection and try again.';
        errorType = 'warning';
      } else if (error.message.includes('Authentication')) {
        errorMessage = 'Authentication required. Please log in again.';
        errorType = 'error';
      } else {
        errorMessage = 'AI analysis encountered an unexpected error. Please try again.';
        errorType = 'error';
      }
      
      // Show notification with specific error message
      setNotification({
        type: errorType,
        message: `🤖 ${errorMessage}`,
        duration: 8000
      });
      
      setAiStatus('Analysis failed');
    } finally {
      setAiLoading(false);
      setAiProgress(0);
    }
  };


  // Render tab content
  const renderTabContent = () => {
    switch (activeTab) {
      case 'paper':
        return (
          <div className="content-card fade-in paper-trading-panel">
            <div className="paper-trading-header">
              <div>
                <h2 className="setup-title">Paper Trading</h2>
                <p className="setup-subtitle">
                  Simulated US stock signals using your backtest parameters. Orders fill at the next day&apos;s open.
                  Click <strong>Update now</strong> to catch up any missed days (same logic cron will use on the server).
                </p>
              </div>
              <button
                type="button"
                className="btn btn-secondary paper-refresh-btn"
                onClick={fetchPaperSubscriptions}
                disabled={paperSubscriptionsLoading}
              >
                {paperSubscriptionsLoading ? 'Refreshing…' : 'Refresh'}
              </button>
            </div>

            {!userLimits?.can_use_paper_trading && (
              <div className="form-alert form-alert-warning">
                Paper trading requires a Premium or Ultra plan. Upgrade to subscribe from backtest results.
              </div>
            )}

            {userLimits?.can_use_paper_trading && paperSubscriptions.length === 0 && !paperSubscriptionsLoading && (
              <div className="paper-empty-state">
                <p>No paper subscriptions yet.</p>
                <p className="paper-empty-hint">Run a backtest, then click <strong>Paper Trade</strong> on a stock-strategy card to start.</p>
              </div>
            )}

            {paperSubscriptionsLoading && paperSubscriptions.length === 0 && (
              <p className="paper-loading">Loading subscriptions…</p>
            )}

            <div className="paper-subscriptions-grid">
              {paperSubscriptions.map((sub) => {
                const trades = [...(sub.trades || [])].sort((a, b) => {
                  const da = new Date(a.trade_date) - new Date(b.trade_date);
                  if (da !== 0) return da;
                  return (a.id || 0) - (b.id || 0);
                });
                const isExpanded = expandedPaperId === sub.id;
                const realized = sub.realized_pl != null ? Number(sub.realized_pl) : 0;
                return (
                <div key={sub.id} className={`paper-subscription-card status-${sub.status}`}>
                  <div className="paper-card-top">
                    <div>
                      <h3 className="paper-card-title">{sub.ticker}</h3>
                      <p className="paper-card-strategy">{sub.strategy_display_name}</p>
                    </div>
                    <span className={`paper-status-badge ${sub.status}`}>{sub.status}</span>
                  </div>

                  <div className="paper-metrics-grid">
                    <div className="paper-metric">
                      <span className="paper-metric-label">Current signal</span>
                      <span className="paper-metric-value">{formatPaperSignal(sub.current_signal)}</span>
                    </div>
                    <div className="paper-metric">
                      <span className="paper-metric-label">Position</span>
                      <span className="paper-metric-value">{sub.position_open ? 'Long' : 'Flat'}</span>
                    </div>
                    <div className="paper-metric">
                      <span className="paper-metric-label">Entry price</span>
                      <span className="paper-metric-value">
                        {sub.entry_price ? `$${Number(sub.entry_price).toFixed(2)}` : '—'}
                      </span>
                    </div>
                    <div className="paper-metric">
                      <span className="paper-metric-label">Last price</span>
                      <span className="paper-metric-value">
                        {sub.last_price ? `$${Number(sub.last_price).toFixed(2)}` : '—'}
                      </span>
                    </div>
                    <div className="paper-metric">
                      <span className="paper-metric-label">Unrealized P/L</span>
                      <span className={`paper-metric-value ${(sub.unrealized_pl || 0) >= 0 ? 'positive' : 'negative'}`}>
                        {sub.unrealized_pl != null
                          ? `${sub.unrealized_pl >= 0 ? '+' : ''}$${Number(sub.unrealized_pl).toFixed(2)} (${sub.unrealized_pl_pct >= 0 ? '+' : ''}${sub.unrealized_pl_pct}%)`
                          : '—'}
                      </span>
                    </div>
                    <div className="paper-metric">
                      <span className="paper-metric-label">Realized P/L</span>
                      <span className={`paper-metric-value ${realized >= 0 ? 'positive' : 'negative'}`}>
                        {`${realized >= 0 ? '+' : ''}$${realized.toFixed(2)}`}
                      </span>
                    </div>
                    <div className="paper-metric">
                      <span className="paper-metric-label">Total return</span>
                      <span className={`paper-metric-value ${(sub.total_return_pct || 0) >= 0 ? 'positive' : 'negative'}`}>
                        {sub.total_return_pct != null
                          ? `${Number(sub.total_return_pct) >= 0 ? '+' : ''}${Number(sub.total_return_pct).toFixed(2)}%`
                          : '—'}
                      </span>
                    </div>
                    <div className="paper-metric">
                      <span className="paper-metric-label">Equity (MTM)</span>
                      <span className="paper-metric-value">
                        {sub.mark_to_market_equity != null
                          ? `$${Number(sub.mark_to_market_equity).toLocaleString(undefined, { maximumFractionDigits: 2 })}`
                          : '—'}
                      </span>
                    </div>
                    <div className="paper-metric">
                      <span className="paper-metric-label">Trades</span>
                      <span className="paper-metric-value">
                        {sub.trade_count || 0} fills · {sub.closed_trade_count || 0} closed
                      </span>
                    </div>
                    <div className="paper-metric">
                      <span className="paper-metric-label">Paper capital</span>
                      <span className="paper-metric-value">${Number(sub.paper_capital).toLocaleString()}</span>
                    </div>
                  </div>

                  <div className="paper-card-meta">
                    <span>Through: {sub.last_processed_date || '—'}</span>
                    <span>Last updated: {sub.last_updated_at ? new Date(sub.last_updated_at).toLocaleString() : 'Pending first run'}</span>
                    <span>{sub.next_update_hint}</span>
                  </div>

                  <div className="paper-card-actions">
                    {sub.status === 'active' ? (
                      <button type="button" className="btn btn-secondary paper-action-btn" onClick={() => updatePaperSubscriptionStatus(sub.id, 'paused')}>
                        Pause
                      </button>
                    ) : (
                      <button type="button" className="btn btn-secondary paper-action-btn" onClick={() => updatePaperSubscriptionStatus(sub.id, 'active')}>
                        Resume
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-secondary paper-action-btn"
                      onClick={() => runPaperSubscriptionNow(sub.id)}
                      disabled={paperUpdatingId === sub.id || sub.status !== 'active'}
                    >
                      {paperUpdatingId === sub.id ? 'Updating…' : 'Update now'}
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary paper-action-btn"
                      onClick={() => setExpandedPaperId(isExpanded ? null : sub.id)}
                    >
                      {isExpanded ? 'Hide trade book' : 'Trade book'}
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary paper-action-btn"
                      onClick={() => setExpandedSnapshotId(expandedSnapshotId === sub.id ? null : sub.id)}
                    >
                      {expandedSnapshotId === sub.id ? 'Hide why I subscribed' : 'Why I subscribed'}
                    </button>
                    <button type="button" className="btn btn-secondary paper-cancel-btn" onClick={() => cancelPaperSubscription(sub.id)}>
                      Cancel
                    </button>
                  </div>

                  {expandedSnapshotId === sub.id && renderPaperSnapshotPanel(sub)}

                  {isExpanded && (
                    <div className="paper-trade-book">
                      <h4 className="paper-trade-book-title">Trade book since subscribe</h4>
                      {trades.length === 0 ? (
                        <p className="paper-trade-book-empty">No fills yet. Waiting for the next buy/sell signal after catch-up.</p>
                      ) : (
                        <table className="paper-trade-table">
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>Action</th>
                              <th>Price</th>
                              <th>Shares</th>
                              <th>Fees</th>
                              <th>Realized P/L</th>
                            </tr>
                          </thead>
                          <tbody>
                            {trades.map((trade) => (
                              <tr key={trade.id}>
                                <td>{trade.trade_date}</td>
                                <td className={trade.action === 'BUY' ? 'action-buy' : 'action-sell'}>{trade.action}</td>
                                <td>${Number(trade.price).toFixed(2)}</td>
                                <td>{Number(trade.shares).toFixed(4)}</td>
                                <td>${Number(trade.fees).toFixed(2)}</td>
                                <td className={(trade.realized_pl || 0) >= 0 ? 'positive' : 'negative'}>
                                  {trade.realized_pl != null
                                    ? `${Number(trade.realized_pl) >= 0 ? '+' : ''}$${Number(trade.realized_pl).toFixed(2)}`
                                    : '—'}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </div>
                  )}
                </div>
                );
              })}
            </div>
          </div>
        );

      case 'settings':
        return (
          <div className="content-card fade-in">
            <div className="settings-timeframes-container">
              {/* Global Settings Section */}
              <div className="settings-section panel-block">
                <div className="section-title">
                  <span className="section-icon" aria-hidden="true"></span>
                  Global Settings
                </div>
                {(!globalSettings.initialEquity || globalSettings.initialEquity <= 0) && (
                  <div className="form-alert form-alert-error">
                    Please set a valid initial equity amount (minimum $1,000 recommended)
                  </div>
                )}
                <div className="grid-2">
                  <div className="form-group">
                    <label className="form-label">Initial Equity ($)</label>
                    <input
                      type="number"
                      className="form-input"
                      value={globalSettings.initialEquity}
                      onChange={(e) => handleGlobalSettingChange('initialEquity', parseFloat(e.target.value))}
                    />
                    {!!globalSettings.initialEquity && (
                      <div className="form-hint">
                        {Number(globalSettings.initialEquity).toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 })}
                      </div>
                    )}
                    <div className="equity-distribution-option">
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          checked={globalSettings.distributeEquityEqually}
                          onChange={(e) => handleGlobalSettingChange('distributeEquityEqually', e.target.checked)}
                        />
                        <span className="checkbox-text">
                          Distribute initial equity equally among all selected stocks
                        </span>
                      </label>
                      <div className="option-description">
                        If selected, the initial equity will be divided equally among all stocks for the oldest timeframe backtest
                      </div>
                      {globalSettings.distributeEquityEqually && stocks.length > 0 && (
                        <div className="form-alert form-alert-info">
                          Each stock starts with ${(globalSettings.initialEquity / stocks.length).toLocaleString('en-US', { maximumFractionDigits: 2 })}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Slippage ($)</label>
                    <input
                      type="number"
                      step="0.01"
                      className="form-input"
                      value={globalSettings.slippage}
                      onChange={(e) => handleGlobalSettingChange('slippage', parseFloat(e.target.value))}
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Broker Fee ($)</label>
                    <input
                      type="number"
                      className="form-input"
                      value={globalSettings.brokerFee}
                      onChange={(e) => handleGlobalSettingChange('brokerFee', parseFloat(e.target.value))}
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Stop Loss</label>
                    <select
                      className="form-select"
                      value={globalSettings.stopLoss}
                      onChange={(e) => handleGlobalSettingChange('stopLoss', e.target.value)}
                    >
                      <option value="No">No</option>
                      <option value="5%">5%</option>
                      <option value="10%">10%</option>
                      <option value="15%">15%</option>
                      <option value="20%">20%</option>
                    </select>
                  </div>
                </div>
              </div>


            </div>
          </div>
        );

      case 'stocks':
        return (
          <div className="content-card fade-in setup-canvas">
            <div className="setup-header">
              <h2 className="setup-title">Backtest setup</h2>
              <p className="setup-subtitle">
                Configure timeframe, stocks, and strategies in one place
              </p>
            </div>

            <div className="setup-stack">
              <div className="panel-block setup-panel">
                <div className="section-title">
                  Timeframe
                </div>
                <div className="setup-field-row">
                  <div className="form-group setup-field">
                    <label className="form-label" htmlFor="setup-timeframe">
                      History length
                    </label>
                    <select
                      id="setup-timeframe"
                      className="form-select"
                      value={selectedMaxYears}
                      onChange={(e) => {
                        const maxYears = parseInt(e.target.value);
                        const allowedMaxYears = userLimits?.max_years ?? 4;

                        if (maxYears > allowedMaxYears) {
                          setNotification({
                            type: 'warning',
                            message: `Your current plan (${userLimits ? userLimits.user_tier : 'FREE'}) allows up to ${allowedMaxYears} years. Please upgrade to access more years.`
                          });
                          return;
                        }

                        setSelectedMaxYears(maxYears);
                        const newTimeframes = {};
                        for (let i = 1; i <= maxYears; i++) {
                          newTimeframes[i] = true;
                        }
                        setTimeframes(newTimeframes);
                      }}
                    >
                      {Array.from({length: userLimits?.max_years ?? 4}, (_, i) => i + 1).map(year => (
                        <option key={year} value={year}>
                          {year} Year{year > 1 ? 's' : ''}
                        </option>
                      ))}
                    </select>
                    <div className="form-hint">
                      Runs years 1–{selectedMaxYears} in one pass
                    </div>
                  </div>
                </div>
              </div>

              <div className="config-workspace">
              {/* Stocks Section */}
              <div className="stocks-section panel-block setup-panel">
                <div className="section-title">
                  Stocks ({stocks.length})
                  <button className="add-stock-btn" onClick={addStock}>
                    + Add Stock
                  </button>
                </div>
                <div className="grid-3">
                  {stocks.map((stock, index) => (
                    <div key={stock.id} className="stock-card">
                      <div className="stock-number">#{index + 1}</div>
                      <button
                        className="remove-btn"
                        onClick={() => removeStock(stock.id)}
                        disabled={stocks.length === 1}
                      >
                        ×
                      </button>
                      <div className="form-group">
                        <label className="form-label">Market</label>
                        <select
                          className="form-select"
                          value={stock.market}
                          onChange={(e) => handleStockChange(stock.id, 'market', e.target.value)}
                        >
                          <option value="US">US (NASDAQ/NYSE)</option>
                          <option value="NSE">NSE</option>
                          <option value="BSE">BSE</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label className="form-label">Symbol</label>
                        <input
                          type="text"
                          className="form-input"
                          placeholder="e.g. MSFT"
                          value={stock.symbol}
                          onChange={(e) => handleStockChange(stock.id, 'symbol', e.target.value.toUpperCase())}
                        />
                        {stockErrors[stock.id] && (
                          <div className="form-error">
                            {stockErrors[stock.id]}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Trading Strategies Section */}
              <div className="strategies-section panel-block setup-panel">
                <div className="section-title">
                  Strategies
                  <div className="section-title-actions">
                  <button 
                    className="add-strategy-btn"
                    onClick={() => setShowAddStrategyModal(true)}
                    title="Add New Strategy"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M12 5v14M5 12h14"/>
                    </svg>
                    Add Strategy
                  </button>
                    {userLimits && userLimits.user_tier === 'FREE' && (
                      <span className="section-title-hint">
                        Upgrade for advanced strategies
                      </span>
                    )}
                  </div>
                </div>
                <div className="strategies-grid">
                  {strategyInstances.length === 0 ? (
                    <div className="empty-state">
                      <h4>No strategies yet</h4>
                      <p>Add a strategy to start configuring your backtest.</p>
                      <button className="btn btn-secondary" onClick={() => setShowAddStrategyModal(true)}>
                        Add Strategy
                      </button>
                    </div>
                  ) : strategyInstances.map(instance => (
                    <div 
                      key={instance.id} 
                      className={`strategy-card ${instance.enabled ? 'selected' : ''}`}
                      onClick={(e) => {
                        // Don't toggle if clicking on settings button or its children
                        if (!e.target.closest('.strategy-settings-btn') && !e.target.closest('.remove-strategy-btn')) {
                          handleStrategyToggle(instance.id);
                        }
                      }}
                    >
                      <div className="strategy-card-header">
                        <div className="strategy-info">
                          <h4 className="strategy-name">{instance.name}</h4>
                          <p className="strategy-description">{strategyDescriptions[instance.type]}</p>
                        </div>
                        <div className="strategy-controls">
                          <label className="strategy-toggle">
                            <input
                              type="checkbox"
                              checked={instance.enabled}
                              onChange={() => handleStrategyToggle(instance.id)}
                            />
                            <span className="toggle-slider"></span>
                          </label>
                          {instance.enabled && instance.params && Object.keys(instance.params).length > 0 && (
                            <button
                              className="strategy-settings-btn"
                              onClick={(e) => {
                                e.stopPropagation(); // Prevent card click
                                openStrategyParamsModal(instance.id);
                              }}
                              title="Configure Strategy Parameters"
                            >
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>
                                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1 1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1Z"/>
                              </svg>
                            </button>
                          )}
                          <button
                            className="remove-strategy-btn"
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent card click
                              removeStrategyInstance(instance.id);
                            }}
                            title="Remove Strategy"
                          >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <path d="M18 6L6 18M6 6l12 12"/>
                            </svg>
                          </button>
                        </div>
                      </div>
                      {instance.enabled && (
                        <div className="strategy-status">
                          <span className="status-indicator active"></span>
                          <span className="status-text">Active</span>
                        </div>
                      )}
                    </div>
                  ))}
                </div>

              </div>
              </div>
            </div>


          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className={`App ${isAuthenticated ? 'App--authed' : ''}`}>
      <div className={`container ${isAuthenticated ? 'container--shell' : ''}`}>
      {isAuthenticated ? (
        <div className="app-shell">
          <aside className="app-sidebar">
            <div className="sidebar-brand">
              <BrandMark />
              <div className="brand-text">
                <h1 className="brand-name">Stock Backtest</h1>
                <p className="brand-tagline">Daily swing backtests</p>
              </div>
            </div>

            <nav className="sidebar-nav" aria-label="Main">
              {tabs.map(tab => (
                <button
                  key={tab.id}
                  type="button"
                  className={`sidebar-nav-item ${activeTab === tab.id ? 'active' : ''}`}
                  onClick={() => setActiveTab(tab.id)}
                >
                  {tab.label}
                </button>
              ))}
            </nav>

            {(() => {
              const enabledInstances = strategyInstances.filter(instance => instance.enabled);
              const hasStrategies = enabledInstances.length > 0;
              const hasTimeframes = selectedMaxYears > 0;
              const hasValidEquity = globalSettings.initialEquity && globalSettings.initialEquity > 0;
              const canRunBacktest = hasStrategies && hasTimeframes && hasValidEquity;

              return (
                <div className="sidebar-cta">
                  <button
                    className="btn btn-primary sidebar-run-btn"
                    onClick={handleSubmit}
                    disabled={loading || !canRunBacktest}
                  >
                    {loading ? 'Running…' : 'Run Backtest'}
                  </button>
                  <button
                    className="btn btn-secondary"
                    onClick={analyzeResults}
                    disabled={aiLoading || !results || (userLimits && userLimits.user_tier === 'FREE')}
                    aria-label="Run AI analysis for all stock-strategy combinations"
                  >
                    {aiLoading ? 'Analyzing…' : 'AI Analysis'}
                  </button>
                  {!canRunBacktest && (
                    <div className="action-hints">
                      {!hasStrategies && (
                        <p className="action-hint">Enable at least one strategy.</p>
                      )}
                      {!hasTimeframes && (
                        <p className="action-hint">Select a timeframe.</p>
                      )}
                      {!hasValidEquity && (
                        <p className="action-hint">Set initial equity in Settings.</p>
                      )}
                    </div>
                  )}
                </div>
              );
            })()}

            <div className="sidebar-spacer" aria-hidden="true"></div>

            <div className="sidebar-footer">
              {userLimits && (
                <div className="plan-pill-wrap">
                  <span
                    className={`plan-pill ${planPillClass(userLimits.user_tier)}`}
                    tabIndex={0}
                    aria-describedby="plan-pill-tooltip"
                  >
                    {formatPlanName(userLimits.user_tier)}
                    <span className="plan-pill-detail">
                      {userLimits.max_years}y · {userLimits.max_stocks} stocks
                    </span>
                  </span>
                  <div id="plan-pill-tooltip" className="plan-tooltip" role="tooltip">
                    <div className="plan-tooltip-title">
                      {formatPlanName(userLimits.user_tier)} plan
                    </div>
                    <ul className="plan-tooltip-list">
                      {getPlanTooltipLines(userLimits).map((line) => (
                        <li key={line}>{line}</li>
                      ))}
                    </ul>
                    <p className="plan-tooltip-meta">
                      {userLimits.max_years}y = {userLimits.max_years} years of history · {userLimits.max_stocks} = max stocks
                    </p>
                  </div>
                </div>
              )}
              <div className="sidebar-user-row">
                <span className="user-chip">{user?.first_name || user?.username}</span>
                <button
                  className="btn btn-subtle"
                  onClick={handleLogout}
                  aria-label="Logout"
                >
                  Logout
                </button>
              </div>
            </div>
          </aside>

          <main className="app-main" ref={workspaceTopRef}>
          {userLimits && userLimits.user_tier === 'FREE' && showFreeBanner && (
            <div className="upgrade-banner">
              <p>
                Free plan includes 3 stocks, 2 strategies, and 4 years.
                {' '}<strong>Premium</strong> unlocks AI, Excel, and longer history.
              </p>
              <button
                type="button"
                className="upgrade-banner-close"
                onClick={() => setShowFreeBanner(false)}
                aria-label="Dismiss upgrade notice"
              >
                ×
              </button>
            </div>
          )}

          {activeTab === 'stocks' && (() => {
            const stockCount = stocks.filter(s => s.symbol && s.symbol.trim()).length;
            const strategyCount = strategyInstances.filter(i => i.enabled).length;
            const canOpenResults = !!(results || loading || error);
            const canOpenAi = !!(results || aiAnalysis || aiLoading);
            return (
              <div className="workspace-chrome">
                <div className="workspace-tabs" role="tablist" aria-label="Workspace">
                  <button
                    type="button"
                    role="tab"
                    aria-selected={workspaceMode === 'setup'}
                    className={`workspace-tab ${workspaceMode === 'setup' ? 'active' : ''}`}
                    onClick={() => setWorkspaceMode('setup')}
                  >
                    Setup
                  </button>
                  <button
                    type="button"
                    role="tab"
                    aria-selected={workspaceMode === 'results'}
                    className={`workspace-tab ${workspaceMode === 'results' ? 'active' : ''}`}
                    onClick={() => setWorkspaceMode('results')}
                    disabled={!canOpenResults}
                  >
                    Results
                    {results ? <span className="workspace-tab-dot" aria-hidden="true" /> : null}
                  </button>
                  <button
                    type="button"
                    role="tab"
                    aria-selected={workspaceMode === 'ai'}
                    className={`workspace-tab ${workspaceMode === 'ai' ? 'active' : ''}`}
                    onClick={() => setWorkspaceMode('ai')}
                    disabled={!canOpenAi}
                    title={userLimits && userLimits.user_tier === 'FREE' ? 'Upgrade to use AI analysis' : undefined}
                  >
                    AI
                    {aiAnalysis ? <span className="workspace-tab-dot" aria-hidden="true" /> : null}
                  </button>
                </div>

                {(results || loading) && (
                  <div className="workspace-summary">
                    <p className="workspace-summary-text">
                      <span>{stockCount} stock{stockCount === 1 ? '' : 's'}</span>
                      <span className="workspace-summary-sep">·</span>
                      <span>{strategyCount} strateg{strategyCount === 1 ? 'y' : 'ies'}</span>
                      <span className="workspace-summary-sep">·</span>
                      <span>{selectedMaxYears} year{selectedMaxYears === 1 ? '' : 's'}</span>
                    </p>
                    {workspaceMode === 'setup' ? (
                      <button
                        type="button"
                        className="btn btn-subtle workspace-summary-action"
                        onClick={() => setWorkspaceMode('results')}
                        disabled={!results && !loading}
                      >
                        View results
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-subtle workspace-summary-action"
                        onClick={() => setWorkspaceMode('setup')}
                      >
                        Edit setup
                      </button>
                    )}
                  </div>
                )}
              </div>
            );
          })()}

          {(activeTab === 'settings' || activeTab === 'paper' || (activeTab === 'stocks' && workspaceMode === 'setup')) && (
            <div className="main-panel">
              {renderTabContent()}
            </div>
          )}

      {/* Loading State — Results mode */}
      {activeTab === 'stocks' && workspaceMode === 'results' && loading && (
        <div className="status-panel status-panel-loading" ref={backtestLoadingRef}>
          <div className="status-panel-kicker">In progress</div>
          <h3 className="status-panel-title">Running backtest</h3>
          <p className="status-panel-copy">{backtestStatus || 'Preparing run…'}</p>
          <div className="progress-container">
            <div 
              className="progress-bar" 
              style={{ width: `${backtestProgress}%` }}
            ></div>
          </div>
          <p className="status-panel-meta">{backtestProgress}% complete</p>
        </div>
      )}

      {/* Error Display — Results mode */}
      {activeTab === 'stocks' && workspaceMode === 'results' && error && (
        <div className="status-panel status-panel-error">
          <div className="status-panel-kicker">Something went wrong</div>
          <h3 className="status-panel-title">Backtest failed</h3>
          <p className="status-panel-copy">{error}</p>
          <button className="btn btn-secondary" onClick={() => setError(null)}>Dismiss</button>
        </div>
      )}

      {/* Results Section */}
      {activeTab === 'stocks' && workspaceMode === 'results' && results && (
        <div className="results-section">


          <div className="results-header">
            <div className="results-title-section">
              <h3>Backtest Results</h3>
              <p className="results-subtitle">Compare strategies across selected timeframes</p>
              
              {/* Failed Stocks Warning */}
              {(() => {
                const allFailedStocks = new Set();
                Object.keys(results).forEach(timeframe => {
                  const timeframeData = results[timeframe];
                  if (timeframeData && timeframeData.failed_stocks) {
                    timeframeData.failed_stocks.forEach(stock => allFailedStocks.add(stock));
                  }
                });
                
                if (allFailedStocks.size > 0) {
                  const failedStocksList = Array.from(allFailedStocks).join(', ');
                  return (
                    <div className="failed-stocks-warning">
                      <span>Failed to process: <strong>{failedStocksList}</strong>. Check ticker symbols or historical data availability.</span>
            </div>
                  );
                }
                return null;
              })()}
            </div>
            <div className="results-header-actions">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setShowStrategyRollupModal(true)}
                title="Compare each strategy across all stocks vs buy-and-hold"
              >
                Strategy vs B&amp;H
              </button>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '0.25rem' }}>
              <button 
                className="btn btn-secondary" 
                onClick={downloadExcel}
                style={{ 
                  opacity: userLimits && userLimits.user_tier === 'FREE' ? 0.7 : 1
                }}
                title={userLimits && userLimits.user_tier === 'FREE' ? 'Upgrade to access Excel download' : 'Download Excel file'}
              >
              Download Excel
                {userLimits && userLimits.user_tier === 'FREE' && (
                  <span style={{ fontSize: '0.7rem', marginLeft: '0.5rem', opacity: 0.8 }}>Locked</span>
                )}
            </button>
              {userLimits && userLimits.user_tier === 'FREE' && (
                <span style={{
                  fontSize: '0.72rem',
                  color: 'var(--muted)',
                  whiteSpace: 'nowrap',
                  textAlign: 'center'
                }}>
                  Upgrade to download Excel
                </span>
              )}
              </div>
            </div>
          </div>

          {/* Stock Filter and Strategy Tabs */}
          <div className="results-controls">
            {/* Stock Filter */}
            <div className="stock-filter-section">
              <div className="filter-group">
                <label htmlFor="stock-filter">Filter by Stock:</label>
                <select
                  id="stock-filter"
                  className="filter-select"
                  value={topLevelStockFilter}
                  onChange={(e) => {
                    setTopLevelStockFilter(e.target.value);
                    setSelectedStockStrategy(null); // Clear selected card when stock filter changes
                  }}
                >
                  <option value="All">All Stocks</option>
                  {(() => {
                    // Simple direct extraction from results
                    const stocks = new Set();
                    if (results) {
                      Object.keys(results).forEach(timeframe => {
                        if (results[timeframe] && results[timeframe].data) {
                          results[timeframe].data.forEach(row => {
                            if (row.metric === 'Equity Name') {
                              Object.keys(row).forEach(key => {
                                if (key !== 'metric' && row[key]) {
                                  stocks.add(row[key]);
                                }
                              });
                            }
                          });
                        }
                      });
                    }
                    const stocksArray = Array.from(stocks).sort();
                    return stocksArray.map(stock => (
                      <option key={stock} value={stock}>{stock}</option>
                    ));
                  })()}
                </select>
              </div>
              <button 
                className="clear-filters-btn"
                onClick={() => {
                  setTopLevelStockFilter('All');
                  setSelectedStockStrategy(null); // Clear selected card when clearing stock filter
                }}
              >
                Clear Filters
              </button>
            </div>

            {/* Strategy Filter Buttons */}
            <div className="filter-buttons">
              <button 
                className={`filter-btn ${selectedStrategyFilter === 'All' ? 'active' : ''}`}
                onClick={() => {
                  setSelectedStrategyFilter('All');
                  setSelectedStockStrategy(null); // Clear selected card when strategy filter changes
                }}
              >
                All
              </button>
              {(() => {
                // Dynamically extract unique strategies from the data
                const uniqueStrategies = new Set();
                if (results[selectedTimeframeTab]?.data) {
                  // Find the row that contains strategy information
                  const strategyRow = results[selectedTimeframeTab].data.find(row => row.metric === 'Strategy');
                  if (strategyRow) {
                    Object.keys(strategyRow).forEach(key => {
                      if (key !== 'metric' && strategyRow[key]) {
                        uniqueStrategies.add(strategyRow[key]);
                      }
                    });
                  }
                }
                
                return Array.from(uniqueStrategies).map(strategy => (
                  <button 
                    key={strategy}
                    className={`filter-btn ${selectedStrategyFilter === strategy ? 'active' : ''}`}
                    onClick={() => {
                      setSelectedStrategyFilter(strategy);
                      setSelectedStockStrategy(null); // Clear selected card when strategy filter changes
                    }}
                  >
                    {strategy}
                  </button>
                ));
              })()}
            </div>
          </div>

          {/* Results Display */}
          <div className="results-content">
            <div className="ai-section">
              


                                {/* Summary Cards Section */}
                  <div className="summary-cards-section">
                    <h5>Performance Summary (All Timeframes)</h5>
                    <p style={{ color: '#718096', fontSize: '0.9rem', marginBottom: '0.5rem' }}>
                        Aggregated performance metrics across all timeframes
                    </p>
                    <p style={{ color: '#4a5568', fontSize: '0.85rem', marginBottom: '1rem', fontWeight: '600' }}>
                      Timeframes tested: {results ? Object.keys(results).map(tf => tf.replace('Y', 'Y')).join(', ') : 'None'} ({selectedMaxYears} year{selectedMaxYears > 1 ? 's' : ''} selected)
                    </p>
                
                {/* Stock-Strategy Cards */}
                <div className="stocks-section">
                  <h6>Click on any card to view detailed performance</h6>
                  <div className="stocks-grid">
                    {results && calculateAggregatedMetrics()
                      .filter(stockStrategy => selectedStrategyFilter === 'All' || stockStrategy.strategy === selectedStrategyFilter)
                      .sort((a, b) => b.totalReturnAcrossYears - a.totalReturnAcrossYears) // Sort by descending total returns
                      .map((stockStrategy, index) => (
                      <div 
                        key={index} 
                        className={`stock-card ${selectedStockStrategy?.id === stockStrategy.id ? 'selected' : ''}`}
                        onClick={() => {
                          // Toggle selection: if same card is clicked, deselect it
                          if (selectedStockStrategy?.id === stockStrategy.id) {
                            setSelectedStockStrategy(null);
                          } else {
                            setSelectedStockStrategy(stockStrategy);
                            
                            // Auto-scroll to detailed metrics section after a short delay to ensure DOM update
                            setTimeout(() => {
                              const detailedMetricsSection = document.getElementById('detailed-metrics-section');
                              if (detailedMetricsSection) {
                                const elementRect = detailedMetricsSection.getBoundingClientRect();
                                const absoluteElementTop = elementRect.top + window.pageYOffset;
                                const middle = absoluteElementTop - (window.innerHeight / 2);
                                window.scrollTo({
                                  top: middle,
                                  behavior: 'smooth'
                                });
                              }
                            }, 100);
                          }
                        }}
                      >
                        <div className="stock-ticker">{stockStrategy.ticker}</div>
                        <div className="stock-strategy">{stockStrategy.strategy}</div>
                        <div className="stock-metrics">
                          <div className="metric-item">
                            <span className="metric-label">Total Returns</span>
                            <span className={`metric-value ${stockStrategy.totalReturnAcrossYears >= 0 ? 'positive' : 'negative'}`}>
                              {stockStrategy.totalReturnAcrossYears >= 0 ? '+' : ''}{stockStrategy.totalReturnAcrossYears.toFixed(1)}%
                            </span>
                          </div>
                          <div className="metric-item">
                            <span className="metric-label">Avg Total Return</span>
                            <span className={`metric-value ${stockStrategy.avgTotalReturn >= 0 ? 'positive' : 'negative'}`}>
                              {stockStrategy.avgTotalReturn >= 0 ? '+' : ''}{stockStrategy.avgTotalReturn.toFixed(1)}%
                            </span>
                          </div>
                          <div className="metric-item">
                            <span 
                              className="metric-label" 
                              onMouseEnter={(e) => showTooltip(e, 'Average Compound Annual Growth Rate - calculated based on actual holding periods, not total time periods')}
                              onMouseLeave={hideTooltip}
                              style={{ cursor: 'help' }}
                            >
                              Avg CAGR
                            </span>
                            <span className={`metric-value ${stockStrategy.avgCagr >= 0 ? 'positive' : 'negative'}`}>
                              {stockStrategy.avgCagr >= 0 ? '+' : ''}{stockStrategy.avgCagr.toFixed(1)}%
                            </span>
                          </div>
                          <div className="metric-item">
                            <span className="metric-label">Avg Win Rate</span>
                            <span className="metric-value">{stockStrategy.avgWinRate.toFixed(1)}%</span>
                          </div>
                          <div className="metric-item">
                            <span className="metric-label">Avg Max Drawdown</span>
                            <span className="metric-value negative">{stockStrategy.avgMaxDrawdown.toFixed(1)}%</span>
                          </div>
                        </div>
                        
                        {/* Subscribe to Strategy Button */}
                        <div className="subscribe-section">
                          <button 
                            className="subscribe-strategy-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (!userLimits?.can_use_paper_trading) {
                                showUpgradePrompt('Paper trading requires a Premium or Ultra plan.');
                                return;
                              }
                              if (!isUsTicker(stockStrategy.ticker)) {
                                setNotification({
                                  type: 'warning',
                                  message: 'Paper trading is available for US stocks only. Indian tickers (.NS / .BO) are not supported yet.',
                                  duration: 6000,
                                });
                                return;
                              }
                              setShowSubscriptionModal(true);
                              setSelectedSubscriptionStrategy(stockStrategy);
                            }}
                            disabled={!userLimits?.can_use_paper_trading || !isUsTicker(stockStrategy.ticker)}
                            title={
                              !userLimits?.can_use_paper_trading
                                ? 'Upgrade to Premium or Ultra for paper trading'
                                : !isUsTicker(stockStrategy.ticker)
                                  ? 'US stocks only'
                                  : 'Start paper trading with your backtest parameters'
                            }
                          >
                            Paper Trade
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Selected Stock-Strategy Performance (All Timeframes) */}
                {selectedStockStrategy && (
                  <div id="detailed-metrics-section" className="performance-section">
                    <div className="detailed-metrics-header">
                      <div className="detailed-metrics-title">
                        <h3 className="detailed-metrics-heading">Detailed Metrics for {selectedStockStrategy.ticker} - {selectedStockStrategy.strategy}</h3>
                        <p className="detailed-timeframe-info">
                          Timeframes tested: {results ? Object.keys(results).map(tf => tf.replace('Y', 'Y')).join(', ') : 'None'} ({selectedMaxYears} year{selectedMaxYears > 1 ? 's' : ''} selected)
                        </p>

                      </div>
                    </div>
                    <div className="performance-summary-grid">
                      {(() => {
                        const summaryMetrics = calculateStockStrategySummary(selectedStockStrategy.ticker, selectedStockStrategy.strategy);
                        return (
                          <>
                            <div className="performance-card">
                              <div className="performance-label">No. Times in Top 25%</div>
                              <div className="performance-value">{summaryMetrics.top25Count}</div>
                            </div>
                            <div className="performance-card">
                              <div className="performance-label">Avg Max Drawdown</div>
                              <div className="performance-value negative">{summaryMetrics.avgMaxDrawdown.toFixed(2)}%</div>
                            </div>
                            <div className="performance-card">
                              <div className="performance-label">Median Max Drawdown</div>
                              <div className="performance-value negative">{summaryMetrics.medianMaxDrawdown.toFixed(2)}%</div>
                            </div>
                            <div className="performance-card">
                              <div className="performance-label">Max Drawdown (All Years)</div>
                              <div className="performance-value negative">{summaryMetrics.maxDrawdownAllYears.toFixed(2)}%</div>
                            </div>
                            <div className="performance-card">
                              <div className="performance-label">Avg Total Return</div>
                              <div className={`performance-value ${summaryMetrics.avgTotalReturn >= 0 ? 'positive' : 'negative'}`}>
                                {summaryMetrics.avgTotalReturn >= 0 ? '+' : ''}{summaryMetrics.avgTotalReturn.toFixed(2)}%
                              </div>
                            </div>
                            <div className="performance-card">
                              <div className="performance-label">Median Total Return</div>
                              <div className={`performance-value ${summaryMetrics.medianTotalReturn >= 0 ? 'positive' : 'negative'}`}>
                                {summaryMetrics.medianTotalReturn >= 0 ? '+' : ''}{summaryMetrics.medianTotalReturn.toFixed(2)}%
                              </div>
                            </div>
                            <div className="performance-card">
                              <div className="performance-label">Lowest Total Return</div>
                              <div className={`performance-value ${summaryMetrics.lowestTotalReturn >= 0 ? 'positive' : 'negative'}`}>
                                {summaryMetrics.lowestTotalReturn >= 0 ? '+' : ''}{summaryMetrics.lowestTotalReturn.toFixed(2)}%
                              </div>
                            </div>
                            <div className="performance-card">
                              <div className="performance-label">Avg Win Rate</div>
                              <div className="performance-value">{summaryMetrics.avgWinRate.toFixed(2)}%</div>
                            </div>
                            <div className="performance-card">
                              <div className="performance-label">Avg CAGR</div>
                              <div className={`performance-value ${summaryMetrics.avgCagr >= 0 ? 'positive' : 'negative'}`}>
                                {summaryMetrics.avgCagr >= 0 ? '+' : ''}{summaryMetrics.avgCagr.toFixed(2)}%
                              </div>
                            </div>
                            <div className="performance-card">
                              <div className="performance-label">Median CAGR</div>
                              <div className={`performance-value ${summaryMetrics.medianCagr >= 0 ? 'positive' : 'negative'}`}>
                                {summaryMetrics.medianCagr >= 0 ? '+' : ''}{summaryMetrics.medianCagr.toFixed(2)}%
                              </div>
                            </div>
                            <div className="performance-card">
                              <div className="performance-label">Lowest CAGR</div>
                              <div className={`performance-value ${summaryMetrics.lowestCagr >= 0 ? 'positive' : 'negative'}`}>
                                {summaryMetrics.lowestCagr >= 0 ? '+' : ''}{summaryMetrics.lowestCagr.toFixed(2)}%
                              </div>
                            </div>
                            <div className="performance-card">
                              <div className="performance-label">Total Returns</div>
                              <div className={`performance-value ${summaryMetrics.totalReturnAcrossYears >= 0 ? 'positive' : 'negative'}`}>
                                {summaryMetrics.totalReturnAcrossYears >= 0 ? '+' : ''}{summaryMetrics.totalReturnAcrossYears.toFixed(2)}%
                              </div>
                            </div>
                          </>
                        );
                      })()}
                    </div>
                  </div>
                )}
              </div>

              {/* Detailed Metrics Table */}
              <div className="detailed-metrics-section">
                <h5>Detailed Metrics by Strategy</h5>
                
                {/* Timeframe Tabs */}
                <div className="timeframe-tabs">
                  {Object.keys(filterDataByTopLevelFilters(results)).map(tf => (
                    <button
                      key={tf}
                      className={`timeframe-tab ${selectedTimeframeTab === tf ? 'active' : ''}`}
                      onClick={() => {
                        setSelectedTimeframeTab(tf);
                        setSelectedStockStrategy(null); // Clear selected card when timeframe tab changes
                      }}
                    >
                      {tf} Year{parseInt(tf) > 1 ? 's' : ''}
                    </button>
                  ))}
                </div>
                
                {/* Desktop Table View */}
                <div className="table-wrap desktop-only">
                  <table className="table">
                    <tbody>
                      {filterDataByTopLevelFilters(results)[selectedTimeframeTab]?.data
                        .filter(row => row.metric !== 'Total Return Across All Years' && row.metric !== 'Total Return Across All Years (Sum of Independent Yearly Returns)') // Exclude from detailed metrics
                        .map((row, index) => (
                        <tr key={index}>
                          <td className="metric-cell">{row.metric}</td>
                          {(() => {
                            // Sort by Total Percentage Return (descending) - same logic as header
                            const totalReturnRow = filterDataByTopLevelFilters(results)[selectedTimeframeTab].data.find(row => row.metric === 'Total Percentage Return');
                            
                            // Get all column keys and sort them by Total Percentage Return (descending) - same logic as header
                            const sortedKeys = Object.keys(row)
                              .filter(key => key !== 'metric')
                              .filter(key => {
                                if (selectedStrategyFilter === 'All') return true;
                                
                                // Find the strategy name for this column from the data
                                const strategyRow = results[selectedTimeframeTab].data.find(row => row.metric === 'Strategy');
                                if (strategyRow && strategyRow[key]) {
                                  return strategyRow[key] === selectedStrategyFilter;
                                }
                                return false;
                              })
                              .sort((a, b) => {
                                if (totalReturnRow && totalReturnRow[a] && totalReturnRow[b]) {
                                  const aValue = parseFloat(totalReturnRow[a].replace(/[+%]/g, '')) || 0;
                                  const bValue = parseFloat(totalReturnRow[b].replace(/[+%]/g, '')) || 0;
                                  return bValue - aValue; // Sort by Total Percentage Return descending
                                }
                                return 0;
                              });
                            
                            return sortedKeys.map(key => {
                              const value = row[key];
                              
                              // Special handling for Strategy row - no positive/negative styling
                              if (row.metric === 'Strategy') {
                                return (
                                  <td key={key} className="strategy-cell">
                                    {value}
                                  </td>
                                );
                              }
                              
                              const isPercentage = typeof value === 'string' && value.includes('%');
                              const isPositive = typeof value === 'string' && value.includes('+');
                              const isNegative = typeof value === 'string' && value.includes('-');
                              
                              return (
                                <td key={key} className={`value-cell ${isPositive ? 'positive' : isNegative ? 'negative' : ''}`}>
                                  {value}
                                </td>
                              );
                            });
                          })()}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Mobile Card View */}
                <div className="mobile-metrics-container mobile-only">
                  {(() => {
                    const data = filterDataByTopLevelFilters(results)[selectedTimeframeTab]?.data;
                    if (!data) return null;

                    // Get all stock-strategy combinations
                    const totalReturnRow = data.find(row => row.metric === 'Total Percentage Return');
                    const strategyRow = data.find(row => row.metric === 'Strategy');
                    const equityRow = data.find(row => row.metric === 'Equity Name');
                    
                    if (!totalReturnRow || !strategyRow || !equityRow) return null;

                    // Get sorted keys (same logic as desktop)
                    const sortedKeys = Object.keys(totalReturnRow)
                      .filter(key => key !== 'metric')
                      .filter(key => {
                        if (selectedStrategyFilter === 'All') return true;
                        return strategyRow[key] === selectedStrategyFilter;
                      })
                      .sort((a, b) => {
                        if (totalReturnRow[a] && totalReturnRow[b]) {
                          const aValue = parseFloat(totalReturnRow[a].replace(/[+%]/g, '')) || 0;
                          const bValue = parseFloat(totalReturnRow[b].replace(/[+%]/g, '')) || 0;
                          return bValue - aValue;
                        }
                        return 0;
                      });

                    return sortedKeys.map(key => {
                      const strategyName = strategyRow[key] || '';
                      const equityName = equityRow[key] || '';
                      
                      return (
                        <div key={key} className="mobile-metric-card">
                          <div className="mobile-card-header">
                            <h6>{equityName}</h6>
                            <span className="mobile-strategy-name">{strategyName}</span>
                          </div>
                          <div className="mobile-metrics-list">
                            {data
                              .filter(row => row.metric !== 'Total Return Across All Years' && 
                                           row.metric !== 'Total Return Across All Years (Sum of Independent Yearly Returns)')
                              .map((row, index) => {
                                const value = row[key];
                                const isPositive = typeof value === 'string' && value.includes('+');
                                const isNegative = typeof value === 'string' && value.includes('-');
                                
                                return (
                                  <div key={index} className="mobile-metric-item">
                                    <span className="mobile-metric-label">{row.metric}</span>
                                    <span className={`mobile-metric-value ${isPositive ? 'positive' : isNegative ? 'negative' : ''}`}>
                                      {value}
                                    </span>
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      );
                    });
                  })()}
                </div>
              </div>

              {/* Detailed Trades Table */}
              <div className="trades-section">
                <h5>📋 Detailed Trades ({selectedTimeframeTab} Year{parseInt(selectedTimeframeTab) > 1 ? 's' : ''})</h5>
                
                {/* Trade Filters */}
                <div className="trade-filters">
                  <div className="filter-group">
                    <label>Equity:</label>
                    <select 
                      value={tradeEquityFilter} 
                      onChange={(e) => setTradeEquityFilter(e.target.value)}
                      className="filter-select"
                    >
                      <option value="All">All Equities</option>
                      {filterDataByTopLevelFilters(results)[selectedTimeframeTab]?.trades && 
                        [...new Set(filterDataByTopLevelFilters(results)[selectedTimeframeTab].trades.map(trade => trade.equity))]
                          .sort()
                          .map(equity => (
                            <option key={equity} value={equity}>{equity}</option>
                          ))
                      }
                    </select>
                  </div>
                  
                  <div className="filter-group">
                    <label>Strategy:</label>
                    <select 
                      value={tradeStrategyFilter} 
                      onChange={(e) => setTradeStrategyFilter(e.target.value)}
                      className="filter-select"
                    >
                      <option value="All">All Strategies</option>
                      {filterDataByTopLevelFilters(results)[selectedTimeframeTab]?.trades && 
                        [...new Set(filterDataByTopLevelFilters(results)[selectedTimeframeTab].trades.map(trade => trade.strategy_name))]
                          .sort()
                          .map(strategy => (
                            <option key={strategy} value={strategy}>{strategy}</option>
                          ))
                      }
                    </select>
                  </div>
                  
                  <div className="filter-group">
                    <label>Exit Reason:</label>
                    <select 
                      value={tradeExitReasonFilter} 
                      onChange={(e) => setTradeExitReasonFilter(e.target.value)}
                      className="filter-select"
                    >
                      <option value="All">All Exit Reasons</option>
                      {filterDataByTopLevelFilters(results)[selectedTimeframeTab]?.trades && 
                        [...new Set(filterDataByTopLevelFilters(results)[selectedTimeframeTab].trades.map(trade => trade.exitReason))]
                          .sort()
                          .map(reason => (
                            <option key={reason} value={reason}>{reason}</option>
                          ))
                      }
                    </select>
                  </div>
                  
                  <button 
                    className="btn btn-subtle"
                    onClick={() => {
                      setTradeEquityFilter('All');
                      setTradeStrategyFilter('All');
                      setTradeExitReasonFilter('All');
                    }}
                  >
                    Clear Filters
                  </button>
                </div>
                
                <div className="table-wrap">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Equity</th>
                        <th>Buy Date</th>
                        <th>Buy Price</th>
                        <th>Shares</th>
                        <th>Buy Signal Type</th>
                        <th>Sell Date</th>
                        <th>Sell Price</th>
                        <th>P/L</th>
                        <th>P/L%</th>
                        <th>Holding Period (Days)</th>
                        <th>Exit Reason</th>
                        <th>Strategy</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filterDataByTopLevelFilters(results)[selectedTimeframeTab]?.trades && filterDataByTopLevelFilters(results)[selectedTimeframeTab].trades
                        .filter(trade => {
                          // Filter by equity
                          if (tradeEquityFilter !== 'All' && trade.equity !== tradeEquityFilter) return false;
                          
                          // Filter by strategy
                          if (tradeStrategyFilter !== 'All' && trade.strategy_name !== tradeStrategyFilter) return false;
                          
                          // Filter by exit reason
                          if (tradeExitReasonFilter !== 'All' && trade.exitReason !== tradeExitReasonFilter) return false;
                          
                          return true;
                        })
                        .map((trade, index) => (
                        <tr key={index}>
                          <td className="equity-cell">{trade.equity}</td>
                          <td>{trade.buyDate}</td>
                          <td>{trade.buyPrice}</td>
                          <td>{trade.shares || 'N/A'}</td>
                          <td>{trade.buySignalType || 'Strategy Signal'}</td>
                          <td>{trade.sellDate}</td>
                          <td>{trade.sellPrice}</td>
                          <td className={trade.pl.includes('-') ? 'negative' : 'positive'}>
                            {trade.pl}
                          </td>
                          <td className={trade.plPercent.includes('+') ? 'positive' : 'negative'}>
                            {trade.plPercent}
                          </td>
                          <td>{trade.holdingPeriod}</td>
                          <td>{trade.exitReason}</td>
                          <td>{trade.strategy_name}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* AI workspace panel */}
      {activeTab === 'stocks' && workspaceMode === 'ai' && (
        <div className="workspace-panel ai-workspace" ref={aiAnalysisRef}>
          <div className="workspace-panel-header">
            <div>
              <h3 className="workspace-panel-title">AI Analysis</h3>
              <p className="workspace-panel-subtitle">
                Insights across all stock–strategy combinations from your latest backtest
              </p>
            </div>
            {aiAnalysis && (
              <button
                type="button"
                className="btn btn-subtle"
                onClick={() => {
                  setAiAnalysis(null);
                  setAiLoading(false);
                  setAiProgress(0);
                  setAiStatus('');
                  setShowAiModal(false);
                  setWorkspaceMode('results');
                }}
              >
                Clear analysis
              </button>
            )}
          </div>

          {aiLoading && (
            <div className="status-panel status-panel-loading" ref={aiAnalysisLoadingRef}>
              <div className="status-panel-kicker">In progress</div>
              <h3 className="status-panel-title">Running AI analysis</h3>
              <p className="status-panel-copy">{aiStatus || 'Analyzing combinations…'}</p>
              <div className="progress-container">
                <div
                  className="progress-bar"
                  style={{ width: `${aiProgress}%` }}
                ></div>
              </div>
              <p className="status-panel-meta">{aiProgress}% complete</p>
            </div>
          )}

          {!aiLoading && aiAnalysis && (
            <div className="ai-analysis-content">
              {aiAnalysis.summary && (
                <div className="ai-section">
                  <h4>Summary</h4>
                  <p>{typeof aiAnalysis.summary === 'object' ? JSON.stringify(aiAnalysis.summary, null, 2) : aiAnalysis.summary}</p>
                </div>
              )}

              {aiAnalysis.top_recommendations && aiAnalysis.top_recommendations.length > 0 && (
                <div className="ai-section">
                  <h4>Top Recommendations</h4>
                  <div className="recommendations-list">
                    {aiAnalysis.top_recommendations.map((rec, index) => (
                      <div key={index} className="recommendation-item">
                        <div className="recommendation-header">
                          <span className="recommendation-rank">#{index + 1}</span>
                          <span className="recommendation-stock">{rec.stock}</span>
                          <span className="recommendation-strategy">{rec.strategy}</span>
                        </div>
                        <p className="recommendation-reasoning">{rec.reasoning}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {aiAnalysis.risk_assessment && (
                <div className="ai-section">
                  <h4>Risk Assessment</h4>
                  <p>{typeof aiAnalysis.risk_assessment === 'object' ? JSON.stringify(aiAnalysis.risk_assessment, null, 2) : aiAnalysis.risk_assessment}</p>
                </div>
              )}

              {aiAnalysis.strategy_insights && (
                <div className="ai-section">
                  <h4>Strategy Insights</h4>
                  <p>{typeof aiAnalysis.strategy_insights === 'object' ? JSON.stringify(aiAnalysis.strategy_insights, null, 2) : aiAnalysis.strategy_insights}</p>
                </div>
              )}

              {aiAnalysis.actionable_advice && (
                <div className="ai-section">
                  <h4>Actionable Advice</h4>
                  <p>{typeof aiAnalysis.actionable_advice === 'object' ? JSON.stringify(aiAnalysis.actionable_advice, null, 2) : aiAnalysis.actionable_advice}</p>
                </div>
              )}
            </div>
          )}

          {!aiLoading && !aiAnalysis && (
            <div className="workspace-empty">
              <h4 className="workspace-empty-title">No AI analysis yet</h4>
              <p className="workspace-empty-copy">
                Run AI Analysis from the sidebar to generate insights from your backtest results.
              </p>
              <button
                type="button"
                className="btn btn-primary"
                onClick={analyzeResults}
                disabled={!results || (userLimits && userLimits.user_tier === 'FREE')}
              >
                {userLimits && userLimits.user_tier === 'FREE' ? 'Upgrade for AI' : 'Run AI Analysis'}
              </button>
            </div>
          )}
        </div>
      )}

      {activeTab === 'stocks' && workspaceMode === 'results' && !results && !loading && !error && (
        <div className="workspace-panel workspace-empty-wrap">
          <div className="workspace-empty">
            <h4 className="workspace-empty-title">No results yet</h4>
            <p className="workspace-empty-copy">
              Configure stocks and strategies on Setup, then run a backtest.
            </p>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setWorkspaceMode('setup')}
            >
              Go to Setup
            </button>
          </div>
        </div>
      )}
          </main>
        </div>
      ) : (
        <div className="login-page">
          <div className="login-container">
            <div className="login-header">
              <BrandMark />
              <h1>Stock Backtest</h1>
              <p>Sign in to your backtesting workspace</p>
            </div>
            
            <div className="login-tabs">
              <button 
                className={`login-tab ${authMode === 'login' ? 'active' : ''}`}
                onClick={() => setAuthMode('login')}
              >
                Login
              </button>
              <button 
                className={`login-tab ${authMode === 'register' ? 'active' : ''}`}
                onClick={() => setAuthMode('register')}
              >
                Register
              </button>
            </div>
            
            <AuthForm 
              mode={authMode}
              onSubmit={authMode === 'login' ? handleLogin : handleRegister}
              loading={authLoading}
              onToggleMode={() => setAuthMode(authMode === 'login' ? 'register' : 'login')}
              onGoogleLogin={handleGoogleLogin}
            />
            
            <div className="login-footer">
              <p>
                {authMode === 'login'
                  ? 'Prefer Google for the fastest way in'
                  : 'Create an account, or switch to Login for Google sign-in'}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* AI Analysis Modal */}
      {showAiModal && (
        <div className="ai-modal-overlay">
          <div className="ai-modal">
            <div className="ai-modal-header">
              <h3>AI Analysis in Progress</h3>
              <button 
                className="ai-modal-close-btn"
                onClick={() => {
                  setShowAiModal(false);
                  setAiLoading(false);
                  setAiProgress(0);
                  setAiStatus('');
                }}
                title="Cancel Analysis"
              >
                ✕
              </button>
            </div>
            <div className="ai-modal-content">
              <div className="ai-modal-context">
                <p className="analysis-context">
                  Analyzing all stock-strategy combinations
                </p>
              </div>
              <div className="ai-modal-progress">
                <div className="progress-container">
                  <div className="progress-bar" style={{ width: `${aiProgress}%` }}></div>
                </div>
                <div className="progress-text">
                  {aiProgress}% Complete
                </div>
              </div>
              <div className="ai-modal-status">
                <p>{aiStatus}</p>
              </div>
              <div className="ai-modal-spinner">
                <div className="loading-spinner"></div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Backtest Progress Modal */}
      {showBacktestModal && (
        <div className="backtest-modal-overlay">
          <div className="backtest-modal">
            <div className="backtest-modal-header">
              <h3>Backtest in Progress</h3>
              <button 
                className="backtest-modal-close-btn"
                onClick={() => {
                  setShowBacktestModal(false);
                  setLoading(false);
                  setBacktestProgress(0);
                  setBacktestStatus('');
                }}
                title="Cancel Backtest"
              >
                ✕
              </button>
            </div>
            <div className="backtest-modal-content">
              <div className="backtest-modal-context">
                <p className="backtest-context">
                  {(() => {
                    const selectedTimeframes = Object.keys(timeframes).filter(tf => timeframes[tf]);
                    const enabledInstances = strategyInstances.filter(instance => instance.enabled);
                    const validStocks = stocks.filter(stock => stock.symbol.trim());
                    
                    return `Testing ${validStocks.length} stocks (${validStocks.map(s => s.symbol).join(', ')}) with ${enabledInstances.length} strategies across ${selectedTimeframes.length} timeframes (${selectedTimeframes.join(', ')} years)`;
                  })()}
                </p>
              </div>
              <div className="backtest-modal-progress">
                <div className="progress-container">
                  <div className="progress-bar" style={{ width: `${backtestProgress}%` }}></div>
                </div>
                <div className="progress-text">
                  {backtestProgress}% Complete
                </div>
              </div>
              <div className="backtest-modal-status">
                <p>{backtestStatus}</p>
              </div>
              <div className="backtest-modal-spinner">
                <div className="loading-spinner"></div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add Strategy Modal */}
      {showAddStrategyModal && (
        <div className="strategy-params-modal-overlay" onClick={() => setShowAddStrategyModal(false)}>
          <div className="strategy-params-modal" onClick={(e) => e.stopPropagation()}>
            <div className="strategy-params-modal-header">
              <h3>➕ Add New Strategy</h3>
              <button 
                className="strategy-params-modal-close-btn"
                onClick={() => setShowAddStrategyModal(false)}
                title="Close"
              >
                ✕
              </button>
            </div>
            <div className="strategy-params-modal-content">
              <div className="add-strategy-options">
                <h4>Select Strategy Type:</h4>
                <div className="strategy-options-grid">
                  {(() => {
                    // Get available strategies based on user tier
                    const availableStrategies = userLimits ? userLimits.available_strategies : ['SMA Crossover', 'RSI Mean Reversion'];
                    
                    // Map backend strategy names to frontend names
                    const strategyMapping = {
                      'SMA Crossover': 'SMA-Crossover',
                      'RSI Mean Reversion': 'RSI-Mean-Reversion',
                      'VWAP Strategy': 'VWAP-Strategy',
                      'Advanced Trend-Following': 'Advanced-Trend-Following',
                      'Advanced Mean-Reversion': 'Advanced-Mean-Reversion',
                      'Hybrid Leading/Lagging': 'Hybrid-Leading/Lagging',
                      'Adaptive Strategy': 'Adaptive-Strategy',
                      'Renko Streak': 'Renko-Streak'
                    };
                    
                    // Filter strategies based on user tier
                    const filteredStrategies = availableStrategies.map(backendName => strategyMapping[backendName]).filter(Boolean);
                    
                    return filteredStrategies.map(strategyType => (
                    <button
                      key={strategyType}
                      className="strategy-option-btn"
                      onClick={() => {
                        addStrategyInstance(strategyType);
                        setShowAddStrategyModal(false);
                      }}
                    >
                      <div className="strategy-option-name">{strategyType}</div>
                      <div className="strategy-option-desc">{strategyDescriptions[strategyType]}</div>
                      {strategyType === 'Adaptive-Strategy' && (
                        <div className="strategy-option-badge" style={{ marginTop: '0.35rem', fontSize: '0.75rem', color: '#38a169', fontWeight: 600 }}>
                          Ultra Premium exclusive
                        </div>
                      )}
                    </button>
                    ));
                  })()}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Strategy Parameters Modal */}
      {showStrategyParamsModal && selectedStrategyForParams && (
        <div className="strategy-params-modal-overlay" onClick={closeStrategyParamsModal}>
          <div className="strategy-params-modal" onClick={(e) => e.stopPropagation()}>
            <div className="strategy-params-modal-header">
              <h3>Configure {selectedStrategyForParams} Parameters</h3>
              <button 
                className="strategy-params-modal-close-btn"
                onClick={closeStrategyParamsModal}
                title="Close"
              >
                ✕
              </button>
            </div>
            <div className="strategy-params-modal-content">
              {(() => {
                const instance = strategyInstances.find(inst => inst.id === selectedStrategyForParams);

                return instance && instance.params && Object.keys(instance.params).length > 0 ? (
                  <div className="strategy-params-form">
                    {instance.type === 'Renko-Streak' ? (
                      <>
                        <div className="param-input-group">
                          <div className="param-label-container">
                            <label htmlFor={`modal-${selectedStrategyForParams}-boxSizeMode`}>Box Size Mode:</label>
                            <button
                              className="info-icon"
                              onMouseEnter={(e) => showTooltip(e, getParameterDescription(instance.type, 'boxSizeMode'))}
                              onMouseLeave={hideTooltip}
                            >
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <circle cx="12" cy="12" r="10"/>
                                <path d="M12 16v-4"/>
                                <path d="M12 8h.01"/>
                              </svg>
                            </button>
                          </div>
                          <select
                            id={`modal-${selectedStrategyForParams}-boxSizeMode`}
                            className="form-select"
                            value={instance.params.boxSizeMode || 'percent'}
                            onChange={(e) => handleStrategyParamChange(selectedStrategyForParams, 'boxSizeMode', e.target.value, false)}
                          >
                            <option value="percent">Percent of price (recommended)</option>
                            <option value="atr">ATR (rolling daily)</option>
                            <option value="manual">Manual (fixed)</option>
                          </select>
                        </div>
                        {['boxPercent', 'boxSize', 'atrPeriod', 'atrMultiplier', 'streakLength'].map((param) => (
                          <div key={param} className="param-input-group">
                            <div className="param-label-container">
                              <label htmlFor={`modal-${selectedStrategyForParams}-${param}`}>
                                {param.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}:
                              </label>
                              <button
                                className="info-icon"
                                onMouseEnter={(e) => showTooltip(e, getParameterDescription(instance.type, param))}
                                onMouseLeave={hideTooltip}
                              >
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                  <circle cx="12" cy="12" r="10"/>
                                  <path d="M12 16v-4"/>
                                  <path d="M12 8h.01"/>
                                </svg>
                              </button>
                            </div>
                            <input
                              id={`modal-${selectedStrategyForParams}-${param}`}
                              type="number"
                              value={instance.params[param] ?? ''}
                              onChange={(e) => handleStrategyParamChange(selectedStrategyForParams, param, e.target.value)}
                              step="any"
                              disabled={
                                (param === 'boxSize' && instance.params.boxSizeMode !== 'manual') ||
                                (param === 'boxPercent' && instance.params.boxSizeMode !== 'percent') ||
                                (['atrPeriod', 'atrMultiplier'].includes(param) && instance.params.boxSizeMode !== 'atr')
                              }
                            />
                          </div>
                        ))}
                        <div className="param-input-group">
                          <label className="checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <input
                              type="checkbox"
                              checked={!!instance.params.confirmNextBrick}
                              onChange={(e) => handleStrategyParamChange(
                                selectedStrategyForParams,
                                'confirmNextBrick',
                                e.target.checked ? 1 : 0
                              )}
                            />
                            <span>Confirm next brick (extra filter)</span>
                          </label>
                        </div>
                        <div className="param-input-group">
                          <label className="checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <input
                              type="checkbox"
                              checked={!!instance.params.trendFilter}
                              onChange={(e) => handleStrategyParamChange(
                                selectedStrategyForParams,
                                'trendFilter',
                                e.target.checked ? 1 : 0
                              )}
                            />
                            <span>Trend filter (directional days only)</span>
                          </label>
                        </div>
                      </>
                    ) : (
                    Object.entries(instance.params).map(([param, value]) => (
                    <div key={param} className="param-input-group">
                      <div className="param-label-container">
                        <label htmlFor={`modal-${selectedStrategyForParams}-${param}`}>
                          {param.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}:
                        </label>
                        <button 
                          className="info-icon"
                          onMouseEnter={(e) => showTooltip(e, getParameterDescription(instance.type, param))}
                          onMouseLeave={hideTooltip}
                        >
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="12" cy="12" r="10"/>
                            <path d="M12 16v-4"/>
                            <path d="M12 8h.01"/>
                          </svg>
                        </button>
                      </div>
                      <input
                        id={`modal-${selectedStrategyForParams}-${param}`}
                        type="number"
                        value={value}
                        onChange={(e) => handleStrategyParamChange(selectedStrategyForParams, param, e.target.value)}
                        step="any"
                      />
                    </div>
                  ))
                    )}
                  <div className="scroll-indicator">
                    <span>End of all parameters</span>
                  </div>
                </div>
              ) : (
                <p>No parameters available for this strategy.</p>
              );
            })()}
            </div>
          </div>
        </div>
      )}

      {/* Global Tooltip */}
      {tooltipState.visible && (
        <div 
          className="global-tooltip"
          style={{
            left: tooltipState.x,
            top: tooltipState.y
          }}
        >
          {tooltipState.content}
        </div>
      )}



      {/* Notification */}
      {notification && (
        <div className={`notification notification-${notification.type}`}>
          <div className="notification-content">
            <span className="notification-icon">
              {notification.type === 'warning' ? '⚠️' : 'ℹ️'}
            </span>
            <span className="notification-message">{notification.message}</span>
            <button 
              className="notification-close"
              onClick={() => setNotification(null)}
              aria-label="Close notification"
            >
              ✕
            </button>
          </div>
        </div>
      )}

      {/* Strategy Rollup Modal */}
      {showStrategyRollupModal && results && (
        <div
          className="strategy-params-modal-overlay"
          onClick={() => {
            setShowStrategyRollupModal(false);
            setExpandedRollupStrategy(null);
          }}
        >
          <div
            className="strategy-params-modal strategy-rollup-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="strategy-params-modal-header">
              <h3>Strategy Rollup vs Buy &amp; Hold</h3>
              <button
                className="strategy-params-modal-close-btn"
                onClick={() => {
                  setShowStrategyRollupModal(false);
                  setExpandedRollupStrategy(null);
                }}
                title="Close"
              >
                ✕
              </button>
            </div>
            <div className="strategy-params-modal-content">
              {renderStrategyRollupPanel()}
            </div>
          </div>
        </div>
      )}

      {/* Paper Trading Subscribe Modal */}
      {showSubscriptionModal && selectedSubscriptionStrategy && (() => {
        const strategyInstance = findStrategyInstanceByName(selectedSubscriptionStrategy.strategy);
        const defaultCapital = getDefaultPaperCapital();
        return (
        <div className="subscription-modal-overlay" onClick={() => {
          setShowSubscriptionModal(false);
        }}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Start Paper Trading</h3>
              <button 
                className="modal-close-btn" 
                onClick={() => {
                  setShowSubscriptionModal(false);
                }}
              >
                ×
              </button>
            </div>
            
            <div className="modal-body">
              <div className="subscription-info">
                <div className="strategy-highlight">
                  <h4>{selectedSubscriptionStrategy.ticker} — {selectedSubscriptionStrategy.strategy}</h4>
                  <p className="strategy-description">
                    Signals are generated at each day&apos;s close and simulated fills execute at the next trading day&apos;s open.
                  </p>
                </div>

                <div className="paper-defaults-summary">
                  <h5>Using your backtest settings</h5>
                  <ul>
                    <li>Strategy parameters from <strong>{selectedSubscriptionStrategy.strategy}</strong></li>
                    <li>Slippage: <strong>{globalSettings.slippage}%</strong> · Broker fee: <strong>${globalSettings.brokerFee}</strong> · Stop loss: <strong>{globalSettings.stopLoss}</strong></li>
                    <li>Paper capital: <strong>${Number(defaultCapital).toLocaleString()}</strong>
                      {globalSettings.distributeEquityEqually ? ' (equity split across stocks)' : ''}
                    </li>
                  </ul>
                  {strategyInstance && (
                    <div className="paper-params-preview">
                      {Object.entries(strategyInstance.params || {}).map(([key, value]) => (
                        <span key={key} className="paper-param-chip">{key}: {String(value)}</span>
                      ))}
                    </div>
                  )}
                </div>

                <div className="paper-customize-section">
                  <button
                    type="button"
                    className="paper-customize-toggle"
                    onClick={() => setShowCustomizePaper((prev) => !prev)}
                  >
                    {showCustomizePaper ? 'Hide customization' : 'Customize paper capital only'}
                  </button>
                  {showCustomizePaper && (
                    <div className="form-group">
                      <label className="form-label">Paper capital ($)</label>
                      <input
                        type="number"
                        className="form-input"
                        min="1000"
                        max={userLimits?.max_paper_capital || 100000}
                        value={paperCapitalInput}
                        onChange={(e) => setPaperCapitalInput(parseFloat(e.target.value) || 0)}
                      />
                      <div className="form-hint">
                        Max for your plan: ${Number(userLimits?.max_paper_capital || 100000).toLocaleString()}
                      </div>
                    </div>
                  )}
                </div>

                <div className="paper-modal-actions">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleStartPaperTrading}
                    disabled={paperSubscribeLoading || !strategyInstance || !results}
                  >
                    {paperSubscribeLoading ? 'Starting…' : 'Start paper trading'}
                  </button>
                  {!results && (
                    <p className="form-hint paper-snapshot-hint">Run a backtest first so we can save what you saw when you subscribe.</p>
                  )}
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowSubscriptionModal(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        );
      })()}

      </div> {/* Close container */}

      {/* Mobile Collapsible CTA */}
      {isAuthenticated && (() => {
        // Calculate if backtest can run
        const enabledInstances = strategyInstances.filter(instance => instance.enabled);
        const hasStrategies = enabledInstances.length > 0;
        const hasTimeframes = selectedMaxYears > 0;
        const hasValidEquity = globalSettings.initialEquity && globalSettings.initialEquity > 0;
        const canRunBacktest = hasStrategies && hasTimeframes && hasValidEquity;
        
        // Count active actions for badge
        let activeActions = 0;
        if (canRunBacktest && !loading) activeActions++;
        if (results && !aiLoading && !(userLimits && userLimits.user_tier === 'FREE')) activeActions++;
        
        return (
          <div className="mobile-cta">
            {!isMobileCTAExpanded ? (
              // Collapsed state - Floating Action Button
              <button 
                className="mobile-cta-fab"
                onClick={() => setIsMobileCTAExpanded(true)}
                aria-label="Open actions menu"
              >
                Go
                {activeActions > 0 && (
                  <span className="mobile-cta-badge">{activeActions}</span>
                )}
              </button>
            ) : (
              // Expanded state - Action Panel
              <div className="mobile-cta-expanded">
                <div className="mobile-cta-header">
                  <span className="mobile-cta-title">Quick Actions</span>
                  <button 
                    className="mobile-cta-close"
                    onClick={() => setIsMobileCTAExpanded(false)}
                    aria-label="Close actions menu"
                  >
                    ✕
                  </button>
                </div>
                <div className="mobile-cta-actions">
                  <button 
                    className="btn btn-primary" 
                    onClick={(e) => {
                      handleSubmit(e);
                      setIsMobileCTAExpanded(false);
                    }}
                    disabled={loading || !canRunBacktest}
                  >
                    {loading ? 'Running...' : 'Run Backtest'}
                  </button>
                  <button 
                    className="btn btn-secondary" 
                    onClick={(e) => {
                      analyzeResults();
                      setIsMobileCTAExpanded(false);
                    }}
                    disabled={aiLoading || !results || (userLimits && userLimits.user_tier === 'FREE')}
                  >
                    {aiLoading ? 'Analyzing...' : 'AI Analysis'}
                  </button>
                  {userLimits && userLimits.user_tier === 'FREE' && (
                    <div style={{ 
                      fontSize: '0.8rem', 
                      color: 'var(--muted)', 
                      textAlign: 'center', 
                      padding: '0.5rem' 
                    }}>
                      Upgrade for AI Analysis
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        );
      })()}
    </div>
  );
}

export default App;
